import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs";
import { getPlantData, getClimateData, updateDesign, getDesigns } from "../../store/design/actions"
import { getAreas, updateArea, fetchCustomPlants, saveCustomPlant, updateCustomPlant, deleteCustomPlant,
    deleteArea, addArea, searchGuild } from "../../store/goals/actions"
import { createJournalEntry, deleteJournalEntry, getJournalTimeline, updateJournalEntry } from "../../store/journal/actions"
import moment from 'moment';
import classnames from "classnames"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid';
import Editable from 'react-x-editable'
import DatePicker from "react-datepicker"
import "ag-grid-community/styles/ag-grid.css";         // Core grid CSS
import "ag-grid-community/styles/ag-theme-alpine.css"; // Theme
import PlantGrid from "./PlantGrid";
import CustomPlantModal from "./CustomPlantModal";
import CropPlanner from "./crop-planner";
import ColumnSelector from "./ColumnSelector";
import {
  addNewEvent, deleteEvent
} from "../../store/calendar/actions"
import { useDrop } from "react-dnd";
import { getProfile } from "../../store/auth/profile/actions"
const Spline = require('cubic-spline');
import ReactApexChart from "react-apexcharts"

import {
    Alert,
  Badge,
  Col,
  Collapse,
  CardHeader,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
  Dropdown,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
    ModalFooter,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
  TabContent,
  TabPane,
  Input,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"

import { StorageImage } from '@aws-amplify/ui-react-storage';

import { Storage } from '@aws-amplify/storage'
import { Image } from '@aws-amplify/ui-react'
import Area from "./area"
import PlantSelect from "./PlantSelect"
import {jsPDF} from 'jspdf';
import 'jspdf-autotable';

const PlantList = props => {
    const {
        plantData,
        profile,
        climateData,
        designs,
        plantMap,
        onAddNewEvent,
        onDeleteEvent,
        guildResults,
        customplants,
        userareas,
        onAddArea,
        onGetCustomPlants,
        onSearchGuild,
        onDeleteArea,
        onDeleteCustomPlant,
        onUpdateArea,
        onUpdateCustomPlant,
        onSaveCustomPlant,
        onSaveDesign,
        onGetProfile,
        onGetClimateData,
        onGetPlantData,
        onGetAreas,
        timelineNotes,
        onCreateJournalEntry,
        onDeleteJournalEntry,
        onGetJournalTimeline,
        onUpdateJournalEntry,
        onLoadDesigns,
    } = props
    const [currHarvests, setCurrHarvests] = useState([])
    const [welcomeModal, setWelcomeModal] = useState(false)
    const [singlebtn, setSinglebtn] = useState(false)
    const [expandMenu, setExpandMenu] = useState(false)
    const [plantModal, setPlantModal] = useState(false)
    const [copyFromPrevious, setCopyFromPrevious] = useState(false);
    const [cropPlannerOpen, setCropPlannerOpen] = useState(false);
    const [isCreatingCustomPlant, setIsCreatingCustomPlant] = useState(false);
    const [customPlantModalOpen, setCustomPlantModalOpen] = useState(false);
    const [customPlantModalMode, setCustomPlantModalMode] = useState("create"); // "create" | "edit"
    const [currCustomPlant, setCurrCustomPlant] = useState(null);

    const [selectedFiles, setSelectedFiles] = useState([])
    const [transferRows, setTransferRows] = useState([
        {areaId: "", numPlants: ""}
    ]);
    const [logHarvestRows, setLogHarvestRows] = useState([
        {plantName: "", variety: "", ounces: ""}
    ])
    const [transferModal, setTransferModal] = useState(false)
    const [customClimate, setCustomClimate] = useState({})
    const [addPlantModal, setAddPlantModal] = useState(false)
    const [plantSource, setPlantSource] = useState()
    const [expectedDeliveryDate, setExpectedDeliveryDate] = useState()
    const [orderDate, setOrderDate] = useState()
    const [showCompleted, setShowCompleted] = useState(true);
    const [logHarvestDate, setLogHarvestDate] = useState(new Date());

    function makeDateColumn(header, field) {
        return {
            headerName: header,
            field,
            editable: true,
            cellEditor: "agDateCellEditor",
            cellEditorParams: (params) => ({
                useBrowserDatePicker: true,
                // Convert your stored "M/D/YYYY" string into a real Date ISO object
                value: params.value
                    ? dayjs(params.value, "M/D/YYYY").toDate()
                    : null,
            }),
            // When the editor closes, convert back to your preferred format
            valueParser: (params) => {
                // agDateCellEditor returns a Date object (ISO)
                const parsed = dayjs(params.newValue);
                return parsed.isValid() ? parsed.format("M/D/YYYY") : params.oldValue;
            },
            // Always display M/D/YYYY in the grid
            valueFormatter: (params) => {
                if (!params.value) return "";
                const d = dayjs(params.value, ["M/D/YYYY", "YYYY-MM-DD"]);
                return d.isValid() ? d.format("M/D/YYYY") : params.value;
            },
            width: 150,
        };
    }

    const [addAreaModal, setAddAreaModal] = useState(false)
    const [copyCustomPlantModal, setCopyCustomPlantModal] = useState(false)
    const [customPlant, setCustomPlant] = useState()
    const [currPlant, setCurrPlant] = useState({})
    const [errors, setErrors] = useState({})
    const [currYear, setCurrYear] = useState()
    const [space, setTotalSpace] = useState()
    const [annotations, setAnnotations] = useState({})
    const [lastDatePossible, setLastDatePossible] = useState({})
    const [name, setName] = useState()
    const [variety, setVariety] = useState()
    const [numPlants, setNumPlants] = useState(1)
    const [editAreaModal, setEditAreaModal] = useState(false)
    const [activeTab, setActiveTab] = useState("1")
    const [editTaskModal, setEditTaskModal] = useState(false)
    const [isPlantEdit, setPlantEdit] = useState(false)
    const [plantInfo, setPlantInfo] = useState(false)
    const [plantDates, setPlantDates] = useState(false)
    const [plantHarvests, setPlantHarvests] = useState(false)
    const [plantNotes, setPlantNotes] = useState(false)
    const [customPlantEdit, setCustomPlantEdit] = useState(false)
    const [currArea, setCurrArea] = useState({plants: []})
    const [currGoal, setCurrGoal] = useState({})
    const [currTask, setCurrTask] = useState({})
    const [species, setSpecies] = useState()
    const [showHarvests, setShowHarvests] = useState(false)
    const [spreadsheetArea, setSpreadsheetArea] = useState()
    const [remainingPlants, setRemainingPlants] = useState(currPlant.numPlants);
    const [taskType, setTaskType] = useState()
    const [taskArea, setTaskArea] = useState()
    const [taskPlants, setTaskPlants] = useState([])
    const [taskObjective, setTaskObjective] = useState()
    const [taskStatus, setTaskStatus] = useState()
    const [taskEndDate, setTaskEndDate] = useState()
    const [areas, setAreas] = useState([])
    const [copyArea, setCopyArea] = useState()
    const [logHarvestsDialog, setLogHarvestsDialog] = useState(false)
    const [includeVarieties, setIncludeVarieties] = useState(true);
    const [daysToHarvest, setDaysToHarvest] = useState()
    const [harvestAmount, setHarvestAmount] = useState()
    const [harvestDate, setHarvestDate] = useState()
    const [harvestUnit, setHarvestUnit] = useState()
    const [noteTags, setNoteTags] = useState()
    const [noteDate, setNoteDate] = useState()
    const [notes, setNotes] = useState()
    const [summer, setSummer] = useState(Array(20).fill(false))
    const [spring, setSpring] = useState(Array(20).fill(false))
    const [seasonRotation, setSeasonRotation] = useState("")
    const [fall, setFall] = useState(Array(20).fill(false))
    const [winter, setWinter] = useState(Array(20).fill(false))
    const [seedStartDate, setSeedStartDate] = useState()
    const [actualSeedStartDate, setActualSeedStartDate] = useState()
    const [transplantDate, setTransplantDate] = useState()
    const [text, setText] = useState("")
    const [timelineData, setTimelineData] = useState([])
    const [plantListTimeline, setPlantListTimeline] = useState([])
    const [plantIndex, setPlantIndex] = useState()
    const [areaIndex, setAreaIndex] = useState()
    const [transferError, setTransferError] = useState("");
    const [spreadsheetView, setSpreadsheetView] = useState(false)
    const [normalView, setNormalView] = useState(true)
    const [unitmeasurement, setUnitMeasurement] = useState("imperial")
    const [customPlantsView, setCustomPlantsView] = useState(false)
    const [areaOptions, setAreaOptions] = useState(Array(20).fill(false))
    const [areaExpand, setAreaExpand] = useState(Array(20).fill(false))
    const [goalExpand, setGoalExpand] = useState(Array(20).fill(false))
    const [plantOptions, setPlantOptions] = useState([])
    const [harvestPlantOptions, setHarvestPlantOptions] = useState([])
    const [harvestPlotOptions, setHarvestPlotOptions] = useState({})
    const [plantStatus, setPlantStatus] = useState()
    const [measurementScale, setMeasurementScale] = useState("E")
    const [tableData, setTableData] = useState([])
    const [plantMappings, setPlantMappings] = useState({})
    const [selectedCell, setSelectedCell] = useState()
    const [plantProps, setPlantProps] = useState({})
    const [climateAverages, setClimateAverages] = useState([])
    const [plantingCalendarModal, setPlantingCalendarModal] = useState(false)
    const [plantingDates, setPlantingDates] = useState(false)
    const [plantingMonths, setPlantingMonths] = useState([])

    const username = JSON.parse(localStorage.getItem("user")).user
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const labels = {
        "metric": {
            "weight": "kg",
            "temperature": "°C",
            "space": "sq. m",
            "distance": "meters"
        },
        "imperial": {
            "weight": "oz",
            "temperature": "°F",
            "space": "sq. ft",
            "distance": "inches"
        }
    }

    const plantColumnCatalog = {
        species: {
            headerName: "Plant  🔒",
            field: "species",
            editable: false,
        },
        variety: {
            headerName: "Variety",
            field: "variety",
            editable: true,
        },
        numPlants: {
            headerName: "# of Plants",
            field: "numPlants",
            editable: true,
        },
        area: {
            headerName: "Area",
            field: "area",
            editable: true,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: (areas) => ({
                values: areas.map((a) => a.name),
            }),
        },
        season: {
            headerName: "Life Cycle",
            field: "season",
            editable: true,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values: ["annual", "biennial", "perennial"],
            },
        },
        season_rotation: {
            headerName: "Season",
            field: "season_rotation",
            editable: true,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values: ["", "Spring", "Summer", "Fall", "Winter"],
            },
        },
        status: {
            headerName: "Status",
            field: "status",
            editable: true,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values: ["Purchased","Not Started", "Seed Starting",
                    "Transplanting", "Growing", "Harvesting", "Failed", "Completed"]
            },
        },
        plantFamily: {
            headerName: "Plant Family",
            field: "plant_family",
            editable: true,
        },
        seedStartDate: makeDateColumn("Seed Start Date", "seedStartDate"),
        transplantDate: makeDateColumn("Transplant Date", "transplantDate"),
        harvestDate: makeDateColumn("Harvest Date", "harvestDate"),
        guildFunction: {
            headerName: "Guild Function 🔒",
            field: "guildFunction",
            editable: false,   // 👈 read-only
            valueFormatter: (params) =>
                Array.isArray(params.value) ? params.value.join(", ") : params.value,
        },
        foodForestLayer: {
            headerName: "Food Forest Layer 🔒",
            field: "foodForestLayer",
            editable: false,   // 👈 read-only
            valueFormatter: (params) =>
                Array.isArray(params.value) ? params.value.join(", ") : params.value,
        },
        climate: {
            headerName: "Climate 🔒",
            field: "climate",
            editable: false,   // 👈 read-only
            valueFormatter: (params) =>
                Array.isArray(params.value) ? params.value.join(", ") : params.value,
        },
        usdaMin: {
            headerName: "USDA Zone Min",
            field: "USDAMin",
            editable: true,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
            },
            valueFormatter: (params) => {
                const zoneMap = {
                    1: "1a-1b",
                    2: "2a-2b",
                    3: "3a-3b",
                    4: "4a-4b",
                    5: "5a-5b",
                    6: "6a-6b",
                    7: "7a-7b",
                    8: "8a-8b",
                    9: "9a-9b",
                    10: "10a-10b",
                    11: "11a-11b",
                    12: "12a-12b",
                };
                return zoneMap[params.value] || params.value;
            },
            valueParser: (params) => Number(params.newValue)
        },
        usdaMax: {
            headerName: "USDA Zone Max",
            field: "USDAMax",
            editable: true,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
            },valueFormatter: (params) => {
                const zoneMap = {
                    1: "1a-1b",
                    2: "2a-2b",
                    3: "3a-3b",
                    4: "4a-4b",
                    5: "5a-5b",
                    6: "6a-6b",
                    7: "7a-7b",
                    8: "8a-8b",
                    9: "9a-9b",
                    10: "10a-10b",
                    11: "11a-11b",
                    12: "12a-12b",
                };
                return zoneMap[params.value] || params.value;
            },
            // Parse label → number for saving
            valueParser: (params) => {
                const num = parseInt(params.newValue, 10);
                return isNaN(num) ? null : num;
            },
        },
        yieldPerPlant: {
            headerName: `Yield Per Plant (${labels[unitmeasurement].weight})`,
            field: "yield_per_plant_ounces",
            editable: true,
        },
        spacing: {
            headerName: `Spacing Between Plants (${labels[unitmeasurement].distance})`,
            field: "spacing_between_plants",
            editable: true,
        },
        spaceUsed: {
            headerName: `Amount of Space Used (${labels[unitmeasurement].space})  🔒`,
            field: "spaceUsed",
            editable: false,
        },
        totalHarvest: {
            headerName: `Total Harvest (${labels[unitmeasurement].weight}) 🔒`,
            field: "totalHarvest",
            editable: false,
        },
        minimumTemp: {
            headerName: `Minimum Temperature (${labels[unitmeasurement].temperature})`,
            field: "minimumTemp",
            editable: true,
        },
        maximumTemp: {
            headerName: `Maximum Temperature (${labels[unitmeasurement].temperature})`,
            field: "maximumTemp",
            editable: true,
        },
        germinationTime: {
            headerName: "Days to Germinate",
            field: "germinationTime",
            editable: true,
        },
        daysToTransplant: {
            headerName: "Days to Transplant",
            field: "daysToTransplant",
            editable: true,
        },
        daysToHarvest: {
            headerName: "Days To Harvest",
            field: "daysToHarvest",
            editable: true,
        },
        timeline: {
            headerName: "Timeline",
            field: "timeline",
            editable: false,
            cellRenderer: "TimelineCellRenderer",
            minWidth: 180,
            autoHeight: true,
        },
    };

    const plantSeasonOptions = [
        {
            "value": "Spring",
            "text": "Spring"
        },
        {
            "value": "Summer",
            "text": "Summer"
        },
        {
            "value": "Fall",
            "text": "Fall"
        },
        {
            "value": "Winter",
            "text": "Winter"
        }];

    const plantStatusOptions = [
        {
            "value": "Seed Starting",
            "text": "Seed Starting"
        },
        {
            "value": "Transplanting",
            "text": "Transplanting"
        },
        {
            "value": "Growing",
            "text": "Growing"
        },
        {
            "value": "Harvest",
            "text": "Harvest"
        }];

    const taskTypeOptions = [
        {
            "value": "Maintenance",
            "text": "Maintenance"
        },
        {
            "value": "Cultivation",
            "text": "Cultivation"
        },
        {
            "value": "Research",
            "text": "Research"
        },
        {
            "value": "Harvest",
            "text": "Harvest"
        },
        {
            "value": "Seed Starting",
            "text": "Seed Starting"
        },
        {
            "value": "Transplanting",
            "text": "Transplanting"
        },
        {
            "value": "Seed Saving",
            "text": "Seed Saving"
        }
    ];

    const taskStatusOptions = [
        {
            "value": "Purchased",
            "text": "Purchased"
        },
        {
            "value": "Not Started",
            "text": "Not Started"
        },
        {
            "value": "In Progress",
            "text": "In Progress"
        },
        {
            "value": "Completed",
            "text": "Completed"
        },
        {
            "value": "Paused",
            "text": "Paused"
        },
        {
            "value": "Failed",
            "text": "Failed"
        }
    ];

    const plantListTimelineOptions = {
        chart: {
            type: 'rangeBar',
            toolbar: {
                show: false,
            },

        },
        plotOptions: {
            bar: {
                horizontal: true,
                distributed: true,
                dataLabels: {
                    enabled: false,
                    hideOverflowingLabels: true
                },
                barHeight: '25px',
            }
        },
        xaxis: {
            type: 'datetime'
        },
        grid: {
            row: {
                colors: ['#f3f4f5', '#fff'],
                opacity: 1
            },
        },

        tooltip: {
            y: {
                formatter: function (value) {
                    return value.toString();
                }
            }
        },
        fill: {
            type: 'solid'
        },
    };

    useEffect(() => {
        const total = transferRows.reduce((sum, row) => sum + Number(row.numPlants || 0), 0);
        setRemainingPlants(currPlant.numPlants - total);
    }, [transferRows, currPlant.numPlants]);

    useEffect(() => {
        if (!climateData) return;

        const climateInfo = { ...climateData };

        const climateSeries = [
            {
                name: "Hot Averages",
                color: "#F00505",
                data: [
                    parseFloat(climateInfo["JanMax"]),
                    parseFloat(climateInfo["FebMax"]),
                    parseFloat(climateInfo["MarMax"]),
                    parseFloat(climateInfo["AprMax"]),
                    parseFloat(climateInfo["MayMax"]),
                    parseFloat(climateInfo["JunMax"]),
                    parseFloat(climateInfo["JulMax"]),
                    parseFloat(climateInfo["AugMax"]),
                    parseFloat(climateInfo["SepMax"]),
                    parseFloat(climateInfo["OctMax"]),
                    parseFloat(climateInfo["NovMax"]),
                    parseFloat(climateInfo["DecMax"])
                ]
            },
            {
                name: "Cold Averages",
                color: "#143FA1",
                data: [
                    parseFloat(climateInfo["JanMin"]),
                    parseFloat(climateInfo["FebMin"]),
                    parseFloat(climateInfo["MarMin"]),
                    parseFloat(climateInfo["AprMin"]),
                    parseFloat(climateInfo["MayMin"]),
                    parseFloat(climateInfo["JunMin"]),
                    parseFloat(climateInfo["JulMin"]),
                    parseFloat(climateInfo["AugMin"]),
                    parseFloat(climateInfo["SepMin"]),
                    parseFloat(climateInfo["OctMin"]),
                    parseFloat(climateInfo["NovMin"]),
                    parseFloat(climateInfo["DecMin"])
                ]
            }
        ];

        setClimateAverages(climateSeries);
    }, [climateData]);


    useEffect(() => {

        var plantTable = [];
        for (const area of userareas) {
            if (area.year !== currYear) {
                continue
            }
            for (const plant of area.plants) {
                plantTable.push(normalizePlant(plant, area.name));
                if (!plant.notes) plant.notes = [];
            }
        }

        setTableData(plantTable);
    }, [currYear]);

    const handleTransferRowChange = (index, field, value) => {
        const updated = [...transferRows];

        // Coerce to integer and enforce upper limit
        if (field === "numPlants") {
            let newVal = parseInt(value, 10);
            if (isNaN(newVal)) newVal = "";
            // Calculate how many plants are already allocated (excluding this row)
            const otherTotal = updated.reduce((sum, row, i) => {
                if (i !== index) return sum + Number(row.numPlants || 0);
                return sum;
            }, 0);

            // Max this row can take without exceeding total
            const maxAvailable = currPlant.numPlants - otherTotal;

            // Cap the value if it exceeds maxAvailable
            if (newVal > maxAvailable) newVal = maxAvailable;

            updated[index][field] = newVal;
        } else {
            updated[index][field] = value;
        }

        setTransferRows(updated);
    };

    const addTransferRow = () => {
        setTransferRows([...transferRows, {areaId: "", numPlants: ""}]);
    };

    const removeTransferRow = (index) => {
        const updated = [...transferRows];
        updated.splice(index, 1);
        setTransferRows(updated);
    };

    useEffect(() => {
        if (!logHarvestsDialog) return;

        const unique = new Set();

        userareas.forEach(area => {
            area.plants.forEach(plant => {
                const name = plant.name || plant.species;
                const variety = plant.variety || "";
                const key = includeVarieties ? `${name}__${variety}` : `${name}__`;
                unique.add(key);
            });
        });

        const options = Array.from(unique)
            .map(key => {
                const [name, variety] = key.split("__");
                return {
                    key,
                    label: includeVarieties && variety ? `${name} (${variety})` : name
                };
            })
            .sort((a, b) => a.label.localeCompare(b.label));

        setHarvestPlantOptions(options);
    }, [logHarvestsDialog, userareas, includeVarieties]);

    function openCreateCustomPlantModal() {
        setCustomPlantModalMode("create");
        setCurrCustomPlant({
            id: uuidv4(),
            username,
            name: "",
            species: "",
            variety: "",
            season: "",
            germinationTime: "",
            plantFamily: "",
            spacing_between_plants: "",
            growingCycle: "",
            minimumTemperature: "",
            maximumTemperature: "",
            yieldPerPlant: "",
            size: "",
            numberOfPlants: "",
            daysToHarvest: "",
            climate: [],
            foodForestLayer: [],
            guildFunction: [],
            latinName: "",
            typeOfHarvest: "",
            USDAMin: "",
            USDAMax: "",
            designerIconKey: "",
            cardIconKey: "",
        });
        setCustomPlantModalOpen(true);
    }

    function openEditCustomPlantModal(customplant) {
        setCustomPlantModalMode("edit");
        setCurrCustomPlant(customplant);
        setCustomPlantModalOpen(true);
    }

    async function handleSaveCustomPlant(plant) {
        // Your redux action likely exists already:
        await onSaveCustomPlant(plant);
        // Refresh list (you already fetch custom plants elsewhere)
        onGetCustomPlants();
    }

    async function handleUpdateCustomPlant(plant) {
        await onUpdateCustomPlant(plant);
        onGetCustomPlants();
    }

    async function handleDeleteCustomPlant(plantId) {
        await onDeleteCustomPlant(plantId); // adjust to your action signature
        onGetCustomPlants();
    }


    const handleLogHarvestsRowChange = (index, field, value) => {
        const updated = [...logHarvestRows];

        if (field === "plantKey") {
            const [plantName, variety] = value.split("__");
            updated[index].plantName = plantName;
            updated[index].variety = variety || "";
        } else {
            updated[index][field] = value;
        }

        setLogHarvestRows(updated);
    };

    const addLogHarvestRow = () => {
        setLogHarvestRows([
            ...logHarvestRows,
            {plantName: "", variety: "", ounces: 0}
        ]);
    };

    const removeLogHarvestRow = (index) => {
        const updated = [...logHarvestRows];
        updated.splice(index, 1);
        setLogHarvestRows(updated);
    };

    const closeTransferModal = () => {
        setTransferModal(false)
    }

    const handleTransfer = async () => {
        const total = transferRows.reduce((sum, row) =>
            sum + Number(row.numPlants || 0), 0);
        if (total !== parseInt(currPlant.numPlants)) {
            setTransferError(`You must allocate exactly ${currPlant.numPlants} plants. Currently allocated: ${total}.`);
            return;
        }

        try {
            const updatePromises = transferRows.map(row => {
                const area = userareas.find(a => a.id === row.areaId);
                if (!area) return Promise.resolve(); // skip if area not found

                const updatedArea = {...area};

                // Clone the plant and assign only the portion of plants
                const newPlant = {
                    ...currPlant,
                    numPlants: row.numPlants,
                };

                newPlant.estHarvest = newPlant['yield_per_plant_ounces'] * newPlant.numPlants / 16.0
                var numPerSquareFoot = Math.pow(12 / newPlant["spacing_between_plants"], 2);
                newPlant.spaceUsed = (newPlant.numPlants / numPerSquareFoot).toFixed(2);

                updatedArea.plants = [...(updatedArea.plants || []), newPlant];

                return onUpdateArea(updatedArea);
            });

            setTransferError("");
            if (currArea) {
                const updatedOriginalArea = {...currArea};
                updatedOriginalArea.plants = updatedOriginalArea.plants.filter(p => p.id !== currPlant.id);
                updatePromises.push(onUpdateArea(updatedOriginalArea));
            }

            await Promise.all(updatePromises);
            setTransferModal(false);
        } catch (err) {
            console.error("Transfer failed:", err);
            setTransferError("An error occurred while updating garden areas.");
        }
    };


    function createNewEvent(plant, title, category, startDate) {
        const newevent = {
            id: uuidv4(),
            username: username,
            title: title,
            description: "",
            plant: plant.plant,
            start: startDate,
            category: category
        }
        plant.events.push[newevent.id]
        onAddNewEvent(newevent);
    }

    function monthSpanToDates(startMonth, endMonth, baseYear) {
        const start = new Date(baseYear, startMonth, 1);
        // pick end as last day of endMonth
        let endYear = baseYear;
        if (endMonth < startMonth) endYear += 1; // wraps over Dec→Jan
        const end = new Date(endYear, endMonth + 1, 0); // last day of endMonth
        return { start, end };
    }

    const formatDateToMDY = (date) => {
        return date
            .toLocaleDateString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            })
            .replace(/\//g, "-"); // → "05-10-2025"
    };

    function daysBetween(date1, date2) {
        const oneDay = 24 * 60 * 60 * 1000; // Hours * minutes * seconds * milliseconds
        const firstDate = new Date(date1); // Convert to Date object
        const secondDate = new Date(date2); // Convert to Date object

        const differenceInTime = Math.abs(secondDate - firstDate); // Absolute difference in milliseconds
        const differenceInDays = Math.ceil(differenceInTime / oneDay); // Convert to days

        return differenceInDays;
    }

    function calcPlantingCalendar(plant) {
        var plantWindows = {}
        const baseYear = currYear;

        var plantInfo = {...plant};
        var plantName = plant.species;
        plantWindows[plantName] = {}
        plantWindows[plantName].ranges = []

        var min = parseFloat(plantInfo.minimumTemp);
        var max = parseFloat(plantInfo.maximumTemp);

        var climateInfo = Object.assign({}, climateData);
        if (profile.climates && profile.climates.length > 0) {
            for (var i = 0; i < profile.climates.length; i++) {
                if (profile.climates[i].selected) {
                    climateInfo = profile.climates[i]
                }
            }
        } else {
            if (unitmeasurement === "metric") {
                min = min * 9/5 + 32;
                max = max * 9/5 + 32;
            }
        }

        var minMonth;
        var maxMonth;
        const seasonRanges = {
            "Fall": [9, 10, 11],
            "Winter": [0, 1, 2],
            "Spring": [3, 4, 5],
            "Summer": [6, 7, 8]
        };

        const seasonMonths = seasonRanges[seasonRotation];

        // Step 1: Find all months that meet the min and max temperature criteria
        var plWindow = [];
        for (let i = 0; i < months.length; i++) {
            const minMonthTemp = parseFloat(climateInfo[months[i] + "Min"]);
            const maxMonthTemp = parseFloat(climateInfo[months[i] + "Max"]);
            if (minMonthTemp >= min && maxMonthTemp <= max) {
                plWindow.push(i);
            }
        }

        var climateSeries = [
            {
                name: "Hot Averages",
                color: "#F00505",
                data: [parseFloat(climateInfo["JanMax"]), parseFloat(climateInfo["FebMax"]), parseFloat(climateInfo["MarMax"]), parseFloat(climateInfo["AprMax"]), parseFloat(climateInfo["MayMax"]),
                    parseFloat(climateInfo["JunMax"]), parseFloat(climateInfo["JulMax"]), parseFloat(climateInfo["AugMax"]), parseFloat(climateInfo["SepMax"]),
                    parseFloat(climateInfo["OctMax"]), parseFloat(climateInfo["NovMax"]), parseFloat(climateInfo["DecMax"])]
            },
            {
                name: "Cold Averages",
                color: "#143FA1",
                data: [parseFloat(climateInfo["JanMin"]), parseFloat(climateInfo["FebMin"]), parseFloat(climateInfo["MarMin"]), parseFloat(climateInfo["AprMin"]), parseFloat(climateInfo["MayMin"]),
                    parseFloat(climateInfo["JunMin"]), parseFloat(climateInfo["JulMin"]), parseFloat(climateInfo["AugMin"]), parseFloat(climateInfo["SepMin"]),
                    parseFloat(climateInfo["OctMin"]), parseFloat(climateInfo["NovMin"]), parseFloat(climateInfo["DecMin"])]
            }]

        setClimateAverages(climateSeries)

        if (plWindow.length < 2) {
            setPlantingDates(false)
            setPlantingCalendarModal(true)
            return
        }

        // Step 2: Create contiguous ranges from plWindow
        var ranges = [];
        if (plWindow.length > 0) {
            let start = plWindow[0];
            let pointer = start;

            for (let i = 1; i < plWindow.length; i++) {
                const current = plWindow[i];
                if ((current === pointer + 1) || (pointer === 11 && current === 0)) {
                    // If contiguous, move the pointer
                    pointer = current;
                } else {
                    // Save the range and start a new one
                    ranges.push({start, end: pointer});
                    start = current;
                    pointer = current;
                }
            }

            // Add the final range
            ranges.push({start, end: pointer});
        }

        ranges = ranges
            .map(range => {
                const {start, end} = range;

                // Adjust the start if it's not within the seasonal months
                const adjustedStart = seasonMonths.includes(start) ? start : seasonMonths.find(month => month >= start) || seasonMonths[0];

                // Only include ranges where the adjusted start is valid within the season
                if (seasonMonths.includes(adjustedStart)) {
                    return {start: adjustedStart, end};
                }

                return null; // Exclude ranges that don't align with the season
            })
            .filter(range => range !== null);

        console.log("Plant " + plantName + " has ranges " + ranges);

        // if we have a range, calculate exact dates based off
        var annot = {};
        if (ranges.length > 0) {
            var startWindow, endWindow;
            var dateRanges = [];
            for (var i = 0; i < ranges.length; i++) {
                var startMonth = ranges[i].start;
                var endMonth = ranges[i].end;

                const coarse = monthSpanToDates(startMonth, endMonth, baseYear);
                let sMonth = startMonth, sYear = coarse.start.getFullYear();
                let startDay = null;
                do {
                    startDay = calcExactDay(sMonth, min, max, false, climateInfo, sYear);
                    if (!startDay || isNaN(startDay)) {
                        sMonth = (sMonth + 1) % 12;
                        if (sMonth === 0) sYear += 1;
                    }
                } while (!(startDay instanceof Date && !isNaN(startDay)));

                let endDay = calcExactDay(endMonth, min, max, true, climateInfo, coarse.end.getFullYear());
                // Normalize wrap
                if (endDay < startDay) endDay.setFullYear(endDay.getFullYear() + 1);

                var numDays = (endDay.getTime() - startDay.getTime()) / (1000 * 3600 * 24)
                const daysToHarvest = parseFloat(plantInfo.daysToHarvest);
                const storageDays = parseFloat(plantInfo.storage_days);
                if (numDays > daysToHarvest) {
                    plantWindows[plant.species].ranges.push({"start": startDay, "end": endDay});
                } else {
                    plWindow = {
                        "start": startDay.toDateString(),
                        "end": endDay.toDateString(),
                        "diff": daysBetween(startDay, endDay)
                    }
                }

                if (i == 0) {
                    var annot =
                        {
                            xaxis: [
                                {
                                    x: startDay.getTime(),
                                    x2: endDay.getTime(),
                                    borderColor: '#00E396',
                                    fillColor: '#00E396',
                                    opacity: 0.2,
                                    label: {
                                        style: {
                                            background: '#00E396',
                                            color: '#fff'
                                        }
                                    }
                                }
                            ],
                            yaxis: [
                                {
                                    y: min,
                                    y2: max,
                                    borderColor: '#00E396',
                                    fillColor: '#00E396',
                                    opacity: 0.2,
                                    label: {
                                        style: {
                                            background: '#00E396',
                                            color: '#fff'
                                        }
                                    }
                                }
                            ],
                        }
                    setAnnotations(annot)
                }
            }
        }

        ranges = plantWindows[plant.species].ranges;
        var numweeks = 0;
        plantWindows[plant.species].spaceNeeded = [];
        plantWindows[plant.species].seedStart = [];
        plantWindows[plant.species].transplant = [];
        plantWindows[plant.species].harvest = [];

        if (ranges.length > 0) {
            plant.plantingWindow = annot;
            plant.climateAverages = climateSeries
            var daysToTransplant = 0;
            if (plantInfo.daysToTransplant) {
                daysToTransplant = parseInt(plantInfo.daysToTransplant)
            }

            if (!lastDatePossible) {
                var harvestDate = new Date(ranges[0].start);
                harvestDate.setDate(harvestDate.getDate() + parseInt(plantInfo.daysToHarvest));

                var seedDate = new Date(ranges[0].start);
                seedDate.setDate(seedDate.getDate() - daysToTransplant - parseInt(plantInfo.germinationTime));

                var transplantDate = new Date(ranges[0].start);

                const today = new Date();
                if (seedDate < today) {
                    seedDate.setFullYear(seedDate.getFullYear() + 1);
                    transplantDate.setFullYear(transplantDate.getFullYear() + 1);
                    harvestDate.setFullYear(harvestDate.getFullYear() + 1);
                }

                // Now safe to save or create events
                plant.seedStartDate = `${seedDate.getMonth() + 1}/${seedDate.getDate()}/${seedDate.getFullYear()}`;
                plant.transplantDate = `${transplantDate.getMonth() + 1}/${transplantDate.getDate()}/${transplantDate.getFullYear()}`;
                plant.harvestDate = `${harvestDate.getMonth() + 1}/${harvestDate.getDate()}/${harvestDate.getFullYear()}`;

                createNewEvent(plant, `${plant.species} - Seed Starting`, "Seed Starting", seedDate);
                createNewEvent(plant, `${plant.species} - Transplanting`, "Transplanting", transplantDate);
                createNewEvent(plant, `${plant.species} - Harvesting`, "Harvest", harvestDate);

                setPlantingDates(true);
            } else {
            var harvestDate = new Date(ranges[0].end);
            harvestDate.setDate(harvestDate.getDate());

            var seedDate = new Date(ranges[0].end);
            seedDate.setDate(
                seedDate.getDate() -
                daysToTransplant -
                parseInt(plantInfo.daysToHarvest) -
                parseInt(plantInfo.germinationTime)
            );

            var transplantDate = new Date(ranges[0].end);
            transplantDate.setDate(
                transplantDate.getDate() - parseInt(plantInfo.daysToHarvest)
            );

            // 🔧 Add year-bump safeguard
            const today = new Date();
            if (seedDate < today) {
                seedDate.setFullYear(seedDate.getFullYear() + 1);
                transplantDate.setFullYear(transplantDate.getFullYear() + 1);
                harvestDate.setFullYear(harvestDate.getFullYear() + 1);
            }

            // Format and assign to plant object
            plant.seedStartDate = `${seedDate.getMonth() + 1}/${seedDate.getDate()}/${seedDate.getFullYear()}`;
            plant.transplantDate = `${transplantDate.getMonth() + 1}/${transplantDate.getDate()}/${transplantDate.getFullYear()}`;
            plant.harvestDate = `${harvestDate.getMonth() + 1}/${harvestDate.getDate()}/${harvestDate.getFullYear()}`;

            // Create calendar events
            createNewEvent(plant, `${plant.species} - Seed Starting`, "Seed Starting", seedDate);
            createNewEvent(plant, `${plant.species} - Transplanting`, "Transplanting", transplantDate);
            createNewEvent(plant, `${plant.species} - Harvesting`, "Harvest", harvestDate);

            setPlantingDates(true);
        }

        } else {
            setPlantingDates(false)
            setPlantingMonths(plWindow)
            setPlantingCalendarModal(true)
        }

    }

    const handlePrevYear = () => {
        setCurrYear(currYear - 1);
    };

    const handleNextYear = () => {
        setCurrYear(currYear + 1);
    };


    function calcExactDay(keyMonth, min, max, inv = false, climateInfo, baseYear) {
        const xs = [0, 30, 60];

        const prevMonth = (keyMonth + 11) % 12;
        const nextMonth = (keyMonth + 1) % 12;

        const ymins = [
            parseFloat(climateInfo[months[prevMonth] + "Min"]),
            parseFloat(climateInfo[months[keyMonth] + "Min"]),
            parseFloat(climateInfo[months[nextMonth] + "Min"]),
        ];

        const ymaxs = [
            parseFloat(climateInfo[months[prevMonth] + "Max"]),
            parseFloat(climateInfo[months[keyMonth] + "Max"]),
            parseFloat(climateInfo[months[nextMonth] + "Max"]),
        ];

        const minSpline = new Spline(xs, ymins);
        const maxSpline = new Spline(xs, ymaxs);

        let keyDate = null;
        if (!inv) {
            for (let i = 0; i <= 60; i++) {
                if (minSpline.at(i) >= min && maxSpline.at(i) <= max) { keyDate = i; break; }
            }
        } else {
            for (let i = 60; i >= 0; i--) {
                if (minSpline.at(i) >= min && maxSpline.at(i) <= max) { keyDate = i; break; }
            }
        }
        if (keyDate == null) return null;

        // Build date: start from the 15th of prevMonth in the correct year
        let prevYear = baseYear;
        if (prevMonth > keyMonth && seasonRotation !== "Winter") prevYear -= 1;
        const midPrev = new Date(prevYear, prevMonth, 15);
        const d = new Date(midPrev);
        d.setDate(d.getDate() + keyDate);

        return d;
    }

    const plantingCalendarOptions =
        {
            chart: {
                type: 'area',
                stacked: false,
                height: 350,
                zoom: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            yaxis: {
                min: 0, // Set the minimum value for the y-axis
                max: 120 // Set the maximum value for the y-axis
            },

            xaxis: {
                type: 'datetime',
                categories: [
                    '2024-01-01', '2024-02-01', '2024-03-01', '2024-04-01',
                    '2024-05-01', '2024-06-01', '2024-07-01', '2024-08-01',
                    '2024-09-01', '2024-10-01', '2024-11-01'
                ]
            },
            tooltip: {
                x: {
                    format: 'dd/MM/yy'
                },
            },
            fill: {
                type: 'solid',
                opacity: 0.75
            },
        };


    const timelineOptions = {
        chart: {
            type: 'rangeBar',
            toolbar: {
                show: false,
            },

        },
        plotOptions: {
            bar: {
                horizontal: true,
                distributed: true,
                dataLabels: {
                    hideOverflowingLabels: false
                },
                barHeight: '50%',
                rangeBarGroupRows: true
            }
        },
        xaxis: {
            type: 'datetime'
        },
        grid: {
            row: {
                colors: ['#f3f4f5', '#fff'],
                opacity: 1
            },
        },
        fill: {
            type: 'solid'
        },
        tooltip: {
            y: {
                formatter: function (value, {series, seriesIndex, dataPointIndex, w}) {
                    if (dataPointIndex % 2 == 0) {
                        return "Seed Starting: "
                    } else {
                        return "Transplanting: "
                    }
                }
            },
        }
    };

    var editMode = false;
    var selectedPlantId;
    var newCellData;

    useEffect(() => {
        onGetProfile(username)
        onGetPlantData()
        onGetAreas()
        onLoadDesigns()
        onGetCustomPlants()
        onGetJournalTimeline({ username })
        setCurrYear(new Date().getFullYear())
    }, [])

    useEffect(() => {
        if (profile.unitmeasurement && profile.unitmeasurement.length > 0) {
            setUnitMeasurement(profile.unitmeasurement)
        }
        if (profile.address) {
            onGetClimateData(profile.address.zipcode)

            setPlantProps({
                daysToTransplant: "Days For Seedling",
                numPlants: "Number Of Plants",
                daysToHarvest: "Days To Harvest",
                germinationTime: "Germination Time",
                minimumTemp: "Minimum Temperature (" + labels[unitmeasurement].temperature + ")",
                maximumTemp: "Maximum Temperature (" + labels[unitmeasurement].temperature + ")",
                yield_per_plant_ounces: "Yield Per Plant (" + labels[unitmeasurement].weight + ")",
                plant_family: "Plant Family",
                season: "Growing Cycle",
                size: "Size",
                foodForestLayer: "Food Forest Layer",
                guildFunction: "Guild Function",
                climate: "Climate",
                USDAMax: "USDA Max Zone",
                USDAMin: "USDA Min Zone",
                spacing_between_plants: "Spacing between Plants (" + labels[unitmeasurement].distance + ")"
            })
        }
    }, [profile])

    useEffect(() => {
        const confirmedOptions = plantData.map((x) => ({ value: x.name, text: x.name }));
        const customOptions = customplants.map((x) => ({ value: x.species, text: `${x.species} (custom)` }));
        setPlantOptions([...confirmedOptions, ...customOptions]);
    }, [plantData, customplants])

    var areaIndices = {}

    function ensureNumericFields(plant, numericFields) {
        const fixed = { ...plant };

        numericFields.forEach((field) => {
            const val = fixed[field];
            if (typeof val === "string") {
                const num = parseFloat(val);
                fixed[field] = Number.isFinite(num) ? num : null; // ✅ gracefully handles "NaN"
            }
        });

        return fixed;
    }

    function ensureLowerCase(plant, lowercaseFields) {
        const fixed = { ...plant };

        lowercaseFields.forEach((field) => {
            const val = fixed[field];
            if (typeof val === "string") {
                fixed[field] = val.toLowerCase();
            } else if (Array.isArray(val)) {
                fixed[field] = val.map((v) =>
                    typeof v === "string" ? v.toLowerCase() : v
                );
            }
        });

        return fixed;
    }

    function normalizePlant(plant, areaName, profile) {
        const numericFields = [
            "spaceUsed",
            "estHarvest",
            "yield_per_plant_ounces",
            "minimumTemp",
            "maximumTemp",
            "spacing_between_plants",
            "daysToHarvest",
            "numPlants",
        ];
        const lowercaseFields = [
            "season",
        ];


        // Convert any numeric-like strings to numbers
        var cleaned = ensureNumericFields(plant, numericFields);
        cleaned = ensureLowerCase(cleaned, lowercaseFields);

        const normalized = {
            ...cleaned,
            area: areaName,
            id: cleaned.id,
            guildFunction: cleaned.guildFunction || [],
            foodForestLayer: cleaned.foodForestLayer || [],
            climate: cleaned.climate || [],
        };

        if (unitmeasurement === "metric") {
            normalized.spaceUsed = (cleaned.spaceUsed / 10.764).toFixed(2);
            normalized.estHarvest = (cleaned.estHarvest / 2.2).toFixed(2);
            normalized.yield_per_plant_ounces = (cleaned.yield_per_plant_ounces / 35.274).toFixed(2);
            normalized.minimumTemp = ((cleaned.minimumTemp - 32) * 5 / 9).toFixed(1);
            normalized.maximumTemp = ((cleaned.maximumTemp - 32) * 5 / 9).toFixed(1);
            normalized.spacing_between_plants = (cleaned.spacing_between_plants*2.54 / 100).toFixed(2);
        }

        return normalized;
    }


    useEffect(() => {
        if (userareas.length == 1)
            setWelcomeModal(true)
        var plantTable = [];
        var spreadsheetPlantMappings = {};
        var plantcount = 0;
        var areaCount = 0;

        var newTimelineData = []

        var plantTable = [];
        for (const area of userareas) {
            areaIndices[area.id] = areaCount++;
            if (!area.info) area.info = { totalSpace: 0 };
            if (!area.year) area.year = new Date().getFullYear();
            if (area.year !== currYear) {
                continue
            }
            for (const plant of area.plants) {
                plantTable.push(normalizePlant(plant, area.name));
                if (!plant.notes) plant.notes = [];
            }
        }

        setTableData(plantTable);

        var barcolors = ["#008FFB", "#00E396", "#775DD0", "#FEB019"];
        var plData = []
        var plTimeline = []
        for (var i in userareas) {
            var areaTimelineData = [];
            var area = userareas[i];
            area["guilds"] = {};
            var spaceUsed = 0;

            var uniquePlants = new Map(); // (species-variety -> Map(start-end timestamp -> {x, y}))

            // Initialize season totals
            const seasonTotals = {
                Spring: 0,
                Summer: 0,
                Fall: 0,
                Winter: 0,
            };

            for (let j in area.plants) {
                const plant = area.plants[j];
                if (!plant.variety) plant.variety = '';

                // --- Group plants into guilds as before ---
                if (plant.guild && plant.guild !== '') {
                    if (!area["guilds"][plant.guild]) area["guilds"][plant.guild] = [];
                    area["guilds"][plant.guild].push(plant);
                }

                // --- Skip completed or failed plants ---
                if (plant.status === "Complete" || plant.status === "Failed") continue;

                // --- Add to season subtotal ---
                if (plant.season_rotation && seasonTotals.hasOwnProperty(plant.season_rotation)) {
                    seasonTotals[plant.season_rotation] += parseFloat(plant.spaceUsed) || 0;
                }

                // --- Skip plants without valid date data for timeline building ---
                if (!plant.seedStartDate || !plant.harvestDate || !plant.transplantDate) continue;

                const startTimestamp = new Date(plant.seedStartDate).getTime();
                const transplantTimestamp = plant.transplantDate
                    ? new Date(plant.transplantDate).getTime()
                    : startTimestamp;
                const harvestTimestamp = new Date(plant.harvestDate).getTime();

                if (isNaN(startTimestamp) || isNaN(transplantTimestamp) || isNaN(harvestTimestamp)) continue;

                const baseName = `${plant.species}-${plant.variety}`;
                const dateKey = `${startTimestamp}-${harvestTimestamp}`;

                // --- Maintain uniqueness logic for timeline ---
                if (!uniquePlants.has(baseName)) {
                    uniquePlants.set(baseName, new Map());
                }

                const dateMap = uniquePlants.get(baseName);
                let uniqueName = baseName;
                if (dateMap.size > 0) uniqueName = `${baseName} ${dateMap.size + 1}`;

                if (!dateMap.has(dateKey)) {
                    dateMap.set(dateKey, [
                        {
                            x: uniqueName,
                            y: [startTimestamp, transplantTimestamp],
                            fillColor: "#00E396",
                        },
                        {
                            x: uniqueName,
                            y: [transplantTimestamp, harvestTimestamp],
                            fillColor: "#FEB019",
                        },
                    ]);
                }
            }

            const maxSeason = Object.keys(seasonTotals).reduce((a, b) =>
                seasonTotals[a] > seasonTotals[b] ? a : b
            );

            area.spaceUsed = seasonTotals[maxSeason];

            // **Push only the unique plant timelines**
            var dataWrapper = [{data: Array.from(uniquePlants.values()).flatMap(m => Array.from(m.values()).flat())}];
            newTimelineData.push(dataWrapper);
        }


        var plDataWrapper = [{
            data: plData
        }]
        plTimeline.push(plDataWrapper)
        setAreas(userareas)

        setTimelineData(newTimelineData)
        setPlantListTimeline(plDataWrapper)

        //check plant ids and generate if not there
        for (var areakey in areas) {
            var area = areas[areakey]
            var plantsNeedId = false;
            for (var plantkey in area.plants) {
                var plant = area.plants[plantkey]
                if (!plant.id) {
                    plantsNeedId = true;
                    plant.id = uuidv4();
                }
            }
            if (plantsNeedId) {
                onUpdateArea(area)
            }
        }

    }, [currPlant, userareas])

    function transferPlant(areaIndex, plantIndex) {
        var currArea = areas[areaIndex]
        setCurrArea(currArea)
        var plant = currArea.plants[plantIndex]
        if (plant) {
            setTransferModal(true)
            setCurrPlant(plant)
        }
    }


    function deletePlant(areaIndex, plantIndex) {
        var currArea = undefined
        for (var areakey in areas) {
            var area = areas[areakey]
            if (area.id == areaIndex) {
                currArea = area;
            }
        }
        if (currArea == undefined) return;

        var newArea = {...currArea}
        var plant = newArea.plants[plantIndex]
        newArea.plants.splice(plantIndex, 1)
        currArea = newArea
        if (plant.events && plant.events.length > 0) {
            for (var i = 0; i < plant.events.length; i++) {
                onDeleteEvent(plant.events[i])
            }
        }
        // also delete from Designer
        const updatedDesign = {
            ...designs[0],
            plants: designs[0].plants.filter(p => p.id !== plant.id),
        };

        // Compare length to know if anything changed
        const changed = updatedDesign.plants.length !== designs[0].plants.length;

        if (changed) {
            onSaveDesign(updatedDesign);
        }

        onUpdateArea(currArea)
    }


    function closeCustom() {
        setPlantModal(false)
    }

    function closeWelcome() {
        setWelcomeModal(false)
    }


    function closePlantingCalendar() {
        setPlantingCalendarModal(false)
    }

    function newCustomPlant() {
        setIsCreatingCustomPlant(true);

        // Start with a minimal object + whatever defaults you want
        setCurrPlant({
            id: uuidv4(),
            name: "",
            species: "",
            variety: "",
            lifecycle: "",
            season: "",
            season_rotation: "",
            daysToHarvest: "",
            inventory: "",
            // new icon fields:
            designerIconKey: "",
            cardIconKey: "",
            // anything else your DB requires:
            username,
        });

        setPlantModal(true);
    }

    function editCustom(customplant) {
        setIsCreatingCustomPlant(false);
        setCurrPlant(customplant);
        setPlantModal(true);
    }

    function removeCustomPlant(customplant) {
        onDeleteCustomPlant(customplant.id)
    }

    function updateSpecies(species) {
        const newPlant = {...currPlant};
        newPlant.species = species;

        if (plantMap[species]) {
            // confirmed plant — copy all plantProps fields directly
            Object.keys(plantProps).map((key) =>
                newPlant[key] = plantMap[species][key]
            )
        } else {
            // custom plant — normalize field names to match confirmed plant shape
            const cp = customplants.find(p => p.species === species);
            if (cp) {
                newPlant.daysToHarvest = cp.daysToHarvest;
                newPlant.daysToTransplant = cp.daysToTransplant;
                newPlant.germinationTime = cp.germinationTime;
                newPlant.minimumTemp = cp.minimumTemperature;
                newPlant.maximumTemp = cp.maximumTemperature;
                newPlant.yield_per_plant_ounces = cp.yieldPerPlant;
                newPlant.plant_family = cp.plantFamily;
                newPlant.season = cp.season_rotation;
                newPlant.size = cp.size;
                newPlant.spacing_between_plants = cp.spacing_between_plants;
                newPlant.guildFunction = cp.guildFunction;
                newPlant.foodForestLayer = cp.foodForestLayer;
                newPlant.climate = cp.climate;
                newPlant.USDAMin = cp.USDAMin;
                newPlant.USDAMax = cp.USDAMax;
                newPlant.designerIconKey = cp.designerIconKey;
                newPlant.cardIconKey = cp.cardIconKey;
                newPlant.isCustomPlant = true;
            }
        }
        setCurrPlant(newPlant)
    }

    function cancelNewPlant() {
        setAddPlantModal(!addPlantModal)

    }

    function handleAddRotationToArea(areaId, plantsToAdd) {
        const areaIndex = areas.findIndex(a => a.id === areaId);
        if (areaIndex === -1) return;

        const updatedArea = {
            ...areas[areaIndex],
            plants: [
                ...areas[areaIndex].plants,
                ...plantsToAdd
            ]
        };

        onUpdateArea(updatedArea);
    }


    function createNewPlant() {
        var terrors = {}
        var failedValidation = false
        if (numPlants == undefined || numPlants == '') {
            terrors['numPlants'] = "Number of Plants is required"
            failedValidation = true
        }
        if (plantStatus == undefined || plantStatus == '') {
            terrors['status'] = "Plant Status is required"
            failedValidation = true
        }
        if (plantStatus != undefined && plantStatus == 'Purchased' && (plantSource == undefined || plantSource == '')) {
            terrors['plantSource'] = "Plant Source is required if status is 'Purchased'"
            failedValidation = true
        }
        if (plantStatus != undefined && plantStatus == 'Purchased' && (orderDate == undefined || orderDate == '')) {
            terrors['orderDate'] = "Order Date is required if status is 'Purchased'"
            failedValidation = true
        }
        if (currPlant == '' || currPlant.species == '') {
            terrors['species'] = "Plant species is required"
            failedValidation = true
        }
        if ((currPlant.season == 'annual' || currPlant.season == 'biennial') && seasonRotation == '') {
            terrors['season'] = "You must select a season for annuals/biennials"
            failedValidation = true
        }
        if (failedValidation) {
            setErrors(terrors)
            return
        }

        currPlant["variety"] = variety
        currPlant["numPlants"] = numPlants
        currPlant["status"] = plantStatus
        if (currPlant["status"] == "Purchased") {
            currPlant["plantSource"] = plantSource
            currPlant["orderDate"] = orderDate
            currPlant["expectedDeliveryDate"] = expectedDeliveryDate
        }
        currPlant["season_rotation"] = seasonRotation
        var numPerSquareFoot = Math.pow(12 / currPlant["spacing_between_plants"], 2);
        var spaceNeeded = (numPlants / numPerSquareFoot).toFixed(2);
        currPlant["spaceUsed"] = spaceNeeded
        currPlant["totalHarvest"] = 0
        if (currPlant["yield_per_plant_ounces"])
            currPlant["estHarvest"] = currPlant["yield_per_plant_ounces"] * numPlants / 16.0;
        else
            currPlant["estHarvest"] = 0
        if (profile.unitmeasurement == "metric") {
            currPlant.spaceUsed = (currPlant.spaceUsed / 10.764).toFixed(2)
            currPlant.estHarvest = (currPlant.estHarvest / 2.2).toFixed(2)
            currPlant.yield_per_plant_ounces = (currPlant.yield_per_plant_ounces / 35.274).toFixed(2)
            currPlant.minimumTemp = ((currPlant.minimumTemp - 32) * 5 / 9).toFixed(2)
            currPlant.maximumTemp = ((currPlant.maximumTemp - 32) * 5 / 9).toFixed(2)
            currPlant["spacing_between_plants"] = (currPlant["spacing_between_plants"] / 2.54).toFixed(2)
        }
        if (currPlant.season == 'annual' || currPlant.season == 'biennial') {
            currPlant.events = []
            calcPlantingCalendar(currPlant)
        }
        let plants = currArea.plants;
        plants.push(currPlant);
        const newArea = {...currArea, [plants]: plants};
        setAddPlantModal(false)

        var plantTable = [];
        for (const area of userareas) {
            for (const plant of area.plants) {
                var plantRow = [];
                plantRow.push({value: plant.species})
                plantRow.push({value: plant.variety})
                plantRow.push({value: plant.numPlants})
                plantRow.push({value: area.name})
                plantRow.push({value: plant.family})
                plantRow.push({value: plant.daysToHarvest})
                plantTable.push(plantRow)
            }
        }
        setTableData(plantTable)
        setErrors({})
        setVariety("")
        onUpdateArea(currArea)
    }

    function normalizePlantForSave(plant, profile) {
        const p = { ...plant };

        if (profile.unitmeasurement === "metric") {
            p.spaceUsed = (p.spaceUsed * 10.764).toFixed(2);
            p.estHarvest = (p.estHarvest * 2.2).toFixed(2);
            p.yield_per_plant_ounces = (p.yield_per_plant_ounces * 35.274).toFixed(2);
            p.minimumTemp = ((p.minimumTemp * 9 / 5) + 32).toFixed(1);
            p.maximumTemp = ((p.maximumTemp * 9 / 5) + 32).toFixed(1);
            p.spacing_between_plants = (p.spacing_between_plants*100/2.54).toFixed(2);
        }

        return p;
    }

    function onCellValueChanged(params) {
        const rawRow = params.data;
        const { colDef, oldValue, newValue, data } = params;

        const field = colDef.field;

        // 🔍 Detect date fields (you can add all your date column fields here)
        const isDateField = ["seedStartDate", "transplantDate", "harvestDate"].includes(field);

        let formattedOld = oldValue;
        let formattedNew = newValue;

        if (isDateField) {
            // Normalize both to the same "M/D/YYYY" format for comparison
            const oldDay = dayjs(oldValue, ["M/D/YYYY", "YYYY-MM-DD"]);
            const newDay = dayjs(newValue);
            formattedOld = oldDay.isValid() ? oldDay.format("M/D/YYYY") : "";
            formattedNew = newDay.isValid() ? newDay.format("M/D/YYYY") : "";
        } else {
            // Normalize non-date values to strings for clean comparison
            formattedOld = String(oldValue ?? "").trim();
            formattedNew = String(newValue ?? "").trim();
        }

        // 🧠 Skip if the value didn’t actually change
        if (formattedOld === formattedNew) {
            console.log(`No change in ${field}, skipping save.`);
            return;
        }

        const updatedRow = normalizePlantForSave(rawRow, profile);

        // Normalize USDA zone numbers if changed
        if (colDef.field === "USDAMin" || colDef.field === "USDAMax") {
            const num = parseInt(newValue, 10);
            if (!isNaN(num)) {
                updatedRow[colDef.field] = num;
            }
        }

        if (colDef.field === "area") {
            const oldArea = areas.find(a =>
                a.plants.some(p => p.id === updatedRow.id)
            );
            const newArea = areas.find(a => a.name === updatedRow.area);

            if (!newArea) return; // invalid selection

            // Remove from old area
            if (oldArea && oldArea !== newArea) {
                oldArea.plants = oldArea.plants.filter(p => p.id !== updatedRow.id);
            }

            // Add or update in new area
            const existingIndex = newArea.plants.findIndex(p => p.id === updatedRow.id);
            if (existingIndex >= 0) {
                newArea.plants[existingIndex] = { ...newArea.plants[existingIndex], ...updatedRow };
            } else {
                newArea.plants.push(updatedRow);
            }

            onUpdateArea && onUpdateArea(newArea);
            if (oldArea && oldArea !== newArea) onUpdateArea(oldArea);

            return;
        }

        // find the right area by name
        const area = areas.find(a => a.name === updatedRow.area);
        if (!area) return;

        // find the plant in that area by id
        const plantIndex = area.plants.findIndex(p => p.id === updatedRow.id);
        if (plantIndex === -1) return;

        // Only update the field that changed
        const updatedPlant = {
            ...area.plants[plantIndex],
            [colDef.field]: updatedRow[colDef.field],
        };

        area.plants[plantIndex] = updatedPlant;

        // push to DB or backend
        onUpdateArea(area);
    }

    function updateSpreadsheet(mode) {
        if (mode == 'edit') {
            editMode = true;
        } else if (mode == 'view') {
            if (editMode && newCellData) {
                // look at cell selected and update Change
                var areaname = newCellData[3].value;
                for (var areakey in areas) {
                    var area = areas[areakey]
                    if (areaname == area.name) {
                        var plants = area.plants;
                        for (var plantkey in plants) {
                            var plant = plants[plantkey]
                            if (plant.id == selectedPlantId) {
                                plant.species = newCellData[0].value
                                plant.variety = newCellData[1].value
                                plant.numPlants = newCellData[2].value
                                plant.family = newCellData[4].value
                                plant.daysToHarvest = newCellData[5].value
                                onUpdateArea(area)
                            }
                        }
                    }
                }
            }
            editMode = false;
        }
    }

    function cellChanged(data) {
        if (selectedCell) {
            newCellData = data[selectedCell];
            selectedPlantId = plantMappings[selectedCell]
        }
    }

    function cellSelected(cells) {
        if (cells.length == 1) {
            if (!editMode)
                setSelectedCell(cells[0].row)
        }

    }

    function toggleFocus(tab) {
        setActiveTab(tab)
    }

    function editTask(goal, taskindex) {
        if (goal) {
            setCurrGoal(goal)
            setCurrTask(goal.tasks[taskindex])
        }
        setEditTaskModal(!editTaskModal)
    }

    function deleteTask(goal, taskindex) {
    }

    function getTaskArea() {
        var listareas = [];
        for (var i = 0; i < areas.length; i++) {
            listareas.push({"value": areas[i].name, "text": areas[i].name})
        }
        return listareas;
    }

    function taskChange(target) {
        if (target.props.name == "taskType") {
            currTask["type"] = target.newValue;
            setCurrTask(currTask);
        } else if (target.props.name == "taskArea") {
            currTask["area"] = target.newValue;
            setCurrTask(currTask);
        } else if (target.props.name == "taskPlants") {
            currTask["plants"] = target.newValue;
            setCurrTask(currTask);
        } else if (target.props.name == "taskObjective") {
            currTask["objective"] = target.newValue;
            setCurrTask(currTask);
        } else if (target.props.name == "taskStatus") {
            currTask["status"] = target.newValue;
            setCurrTask(currTask);
        } else if (target.props.name == "taskEndDate") {
            currTask["endDate"] = target.newValue;
            setCurrTask(currTask);
        }

//onUpdateArea(areas[areaIndex])
    }

    function harvestChange(target) {
        if (target.props.name == "harvestDate") {
            setHarvestDate(target.newValue);
        } else if (target.props.name == "harvestAmount") {
            setHarvestAmount(target.newValue);
        } else {
            setHarvestUnit(target.newVale);
        }
    }


    function createNewArea() {
        // ------------- COPY MODE -------------
        if (copyFromPrevious) {

            const confirmed = window.confirm(
                "Are you sure? This process may copy multiple areas."
            );
            if (!confirmed) return;

            const prevYear = currYear - 1;
            const prevAreas = userareas.filter(a =>
                a.year === prevYear &&
                (a.name || "").toLowerCase() !== "unassigned"   // <-- SKIP UNASSIGNED
            );

            prevAreas.forEach(oldArea => {

                // ---- Helper to shift date strings forward 1 year ----
                function shiftOneYear(str) {
                    if (!str) return null;
                    const d = new Date(str);
                    if (isNaN(d)) return null;
                    d.setFullYear(d.getFullYear() + 1);
                    return d.toISOString();
                }

                // ---- Copy ONLY perennial plants and reset fields ----
                const perennialsOnly = (oldArea.plants || [])
                    .filter(p => {
                        // Ensure season exists, normalize case
                        const season = (p.season || "").toLowerCase();
                        return season === "perennial";
                    })
                    .map(p => ({
                        ...p,
                        id: uuidv4(),

                        // Reset arrays
                        climateAverages: [],
                        harvests: [],
                        notes: [],

                        // Reset numbers
                        harvestTotals: 0,
                        totalHarvest: 0,

                        // Shift dates by +1 year if present
                        seedStartDate: shiftOneYear(p.seedStartDate),
                        transplantDate: shiftOneYear(p.transplantDate),
                        harvestDate: shiftOneYear(p.harvestDate)
                    }));

                const newArea = {
                    id: uuidv4(),
                    name: oldArea.name,
                    year: currYear,

                    // Keep totalSpace, etc.
                    info: { ...oldArea.info },

                    plants: perennialsOnly,

                    // Reset history for new year
                    history: {}
                };

                onAddArea(newArea);
            });

            setAddAreaModal(false);
            return;
        }


        // ------------- NORMAL MODE -------------
        var terrors = {};
        var failedValidation = false;

        if (!space) {
            terrors['space'] = "Total space is required";
            failedValidation = true;
        }

        if (!name) {
            terrors['name'] = "Area name is required";
            failedValidation = true;
        }

        // Allow duplicates across years —
        // block duplicates ONLY in current year
        for (var i = 0; i < userareas.length; i++) {
            var area = userareas[i];
            if (area.name === name && area.year === currYear) {
                terrors['name'] = "Area with this name already exists for this year";
                failedValidation = true;
                break;
            }
        }

        setErrors(terrors);
        if (failedValidation) return;

        const newArea = {
            name: name,
            id: uuidv4(),
            year: currYear,
            info: { totalSpace: space },
            history: {},
            plants: []
        };

        setAddAreaModal(false);
        onAddArea(newArea);
    }

    function changeGoalName(goalIndex) {
    }

    function cancelNewTask() {
        var currTaskSize = currGoal.tasks.length
        currGoal.tasks.splice(currTaskSize - 1, 1)
        setAddTaskModal(!addTaskModal)
    }


    function cancelNewArea() {
        var currAreaSize = areas.length
        areas.splice(currAreaSize - 1, 1)
        setAddAreaModal(!addAreaModal)
    }

    function addGoal() {
    }

    function setAreaSelected(name) {
        for (var i = 0; i < areas.length; i++) {
            var area = areas[i]
            if (area.name == name) {
                setCurrArea(area)
                setSpreadsheetArea(area.name)
            }
        }
    }

    function logHarvests() {
        setLogHarvestsDialog(true)
    }

    function closeLogHarvests() {
        setLogHarvestsDialog(false)
    }

    const createNewHarvestLog = async () => {

        setLogHarvestsDialog(false)
        const unit = unitmeasurement === "imperial" ? "ounces" : "grams";

        const clonedAreas = userareas.map(area => ({
            ...area,
            plants: area.plants.map(p => ({ ...p }))
        }));

        const updatedAreasMap = new Map();

        logHarvestRows.forEach(row => {
            const { plantName, variety, ounces } = row;

            const matched = [];

            // Find all matching plants and count total numPlants
            let totalPlants = 0;

            clonedAreas.forEach(area => {
                area.plants.forEach((plant, plantIndex) => {
                    const nameMatch = ((plant.name === plantName) || (plant.species === plantName));
                    const varietyMatch = includeVarieties ? plant.variety === variety : true;

                    if (nameMatch && varietyMatch) {
                        const groupSize = parseInt(plant.numPlants || 0, 10);
                        totalPlants += groupSize;
                        matched.push({
                            areaId: area.id,
                            area,
                            plantIndex,
                            groupSize
                        });
                    }
                });
            });

            if (matched.length === 0 || totalPlants === 0) return;

            matched.forEach(({ areaId, area, plantIndex, groupSize }) => {
                const proportion = groupSize / totalPlants;
                const amount = parseFloat((proportion * parseFloat(ounces)).toFixed(1));
                const formattedDate = formatDateToMDY(logHarvestDate);

                const harvestItem = {
                    date: formattedDate,
                    amount,
                    unit
                };

                const plant = area.plants[plantIndex];

                if (!plant.harvests) plant.harvests = [];
                plant.harvests.push(harvestItem);

                // Recalculate totalHarvest
                plant.totalHarvest = plant.harvests.reduce(
                    (sum, h) => sum + parseFloat(h.amount || 0),
                    0
                );

                // Register updated area
                if (updatedAreasMap.has(areaId)) {
                    updatedAreasMap.get(areaId).plants[plantIndex] = plant;
                } else {
                    updatedAreasMap.set(areaId, area);
                }
            });
        });

        try {
            const updatePromises = Array.from(updatedAreasMap.values()).map(area =>
                onUpdateArea(area)
            );
            await Promise.all(updatePromises);
        } catch (err) {
            console.error("Error saving harvest logs:", err);
        }
    };

    function addArea () {
        const newArea = {
            name: "",
            id: "",
            year: currYear,
            info: {
                totalSpace: 0
            },
            history: {},
            plants:[]
        }
        //setAreas([...areas, newArea])
        setCurrArea(newArea)
        setAddAreaModal(!addAreaModal)
    }



function filterByYear(target) {
  var newYear = target.newValue;
  setCurrYear(newYear);
}

    function addPlantToSpreadsheet() {
        const newPlant = {
            species:"",
            variety:"",
            id:uuidv4(),
            icon: "",
            seedStartDate: "",
            transplantDate: "",
            harvestDate: "",
            status: "Seed Starting",
            numPlants: "",
            harvests: [],
            notes: [],
            harvestTotals: 0
        }
        setCurrPlant(newPlant)
        setAddPlantModal(!addPlantModal)
    }

function addPlant (areaIndex) {
    setCurrArea(areas[areaIndex])
    const newPlant = {
        species:"",
        variety:"",
        id:uuidv4(),
        icon: "",
        seedStartDate: "",
        transplantDate: "",
        harvestDate: "",
        status: "Seed Starting",
        numPlants: "",
        harvests: [],
        notes: [],
        harvestTotals: 0
    }
    setCurrPlant(newPlant)
    setAddPlantModal(!addPlantModal)
}


const generateYearOptions = () => {
  const arr = [];

  const startYear = 2024;
  const endYear = new Date().getFullYear()+4;

  for (let i = endYear; i >= startYear; i--) {
    arr.push({"value": i,
	      "text": i
            })
  }
  return arr;
};

const generatePdf = () => {
  // Create a new instance of jsPDF

  var doc = new jsPDF('p', 'pt', 'letter');
  var col = ["Plant", "Variety", "# of Plants", "Area", "Season", "Plant Family", "Days To Harvest"]
  var row1 = [];
  // Loops through tabledata
  for (let r of tableData){
    var row2 = [];

    for (let item of r){

    var temporary = item.value;
    row2.push(temporary);
  }
  
  row1.push(row2);
  }
  doc.autoTable(col, row1, {startY: 70});
  doc.setFontSize(18);
  doc.setDrawColor(0);
  // Add a title
  doc.text('My Plantlist', 20, 20);

  // Add some content
  doc.setFontSize(12);
  const blob = doc.save('plantlist.pdf');
     

  };

    function findPlantIndices(userareas, plantId) {
        for (let areaIndex = 0; areaIndex < userareas.length; areaIndex++) {
            const area = userareas[areaIndex];
            const plantIndex = area.plants.findIndex((p) => p.id === plantId);
            if (plantIndex !== -1) {
                // ✅ Found the plant
                return { areaIndex, plantIndex };
            }
        }

        // ❌ Not found
        return { areaIndex: -1, plantIndex: -1 };
    }

function customPlantChange (target) {
     var plant;
     plant = {...currPlant}
     if (plant.transplantDate && !plant.harvestDate) {
         var harvestDate = new Date(plant.transplantDate)
         harvestDate.setDate(harvestDate.getDate() + parseInt(plant.daysToHarvest))
         plant.harvestDate =  (harvestDate.getMonth() + 1) + '/' + (harvestDate.getDate()+1) + '/' + harvestDate.getFullYear();
     }
     if (target.props.name=="seedStartDate") {
          var newDate = new Date(target.newValue);
          plant.seedStartDate = (newDate.getMonth() + 1) + '/' + (newDate.getDate()) + '/' +  newDate.getFullYear();
     } else if (target.props.name=="transplantDate") {
          var newDate = new Date(target.newValue);
          plant.transplantDate = (newDate.getMonth() + 1) + '/' + (newDate.getDate()) + '/' +  newDate.getFullYear();
     } else if (target.props.name=="harvestDate") {
          var newDate = new Date(target.newValue);
          plant.harvestDate =  (newDate.getMonth() + 1) + '/' + (newDate.getDate()) + '/' +  newDate.getFullYear();
     } else {
          plant[target.props.name] = target.newValue
          plant.estHarvest = plant['yield_per_plant_ounces'] * plant.numPlants / 16.0
          var numPerSquareFoot = Math.pow(12/currPlant["spacing_between_plants"],2);
          plant.spaceUsed = (plant.numPlants/numPerSquareFoot).toFixed(2);
       if (profile.unitmeasurement=="metric") {
        plant.spaceUsed = (plant.spaceUsed/10.764).toFixed(2)
        plant.estHarvest = (plant.estHarvest/2.2).toFixed(2)
        plant.yield_per_plant_ounces = (plant.yield_per_plant_ounces/35.274).toFixed(2)
        plant.minimumTemp = ((plant.minimumTemp - 32)*5/9).toFixed(2)
        plant.maximumTemp = ((plant.maximumTemp - 32)*5/9).toFixed(2) 
        plant["spacing_between_plants"] = (plant["spacing_between_plants"] / 2.54).toFixed(2)
      }
     }
     setCurrPlant(plant)
     onUpdateCustomPlant(plant)
  }

function addHarvest (plant) {
    const { areaIndex, plantIndex } = findPlantIndices(areas, plant.id);
    const item1 = { date: harvestDate, amount: harvestAmount}
    plant.harvests.push(item1);
    var totalHarvest = 0
    for (var i=0; i<plant.harvests.length; i++) {
        totalHarvest += parseFloat(plant.harvests[i].amount)
    }
    plant.totalHarvest = totalHarvest
    setAreas(areas);
    onUpdateArea(areas[areaIndex])

    var spaceUsed = 0;

    userareas[areaIndex].plants.map(plant => {
       spaceUsed += parseFloat(plant.spaceUsed);
    });

    userareas[areaIndex].spaceUsed = spaceUsed;
    setAreas(userareas)
}

    function addPlantLog(plant) {
        const area = userareas.find(a => a.plants?.some(p => p.id === plant.id));
        if (!area) return;

        const date = noteDate
            ? dayjs(noteDate).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD");

        const photos = selectedFiles.length > 0
            ? [{ s3_key: `${username}/journal/${date}/${Date.now()}_${selectedFiles[0].name}`, comment: "" }]
            : [];

        if (selectedFiles.length > 0) {
            selectedFiles.forEach((file, i) => {
                const key = `${username}/journal/${date}/${Date.now() + i}_${file.name}`;
                Storage.put(key, file, { contentType: file.type }).catch(console.error);
            });
            setSelectedFiles([]);
        }

        onCreateJournalEntry({
            username,
            area_id: area.id,
            plant_id: plant.id,
            note_text: notes || "",
            tags: noteTags || "",
            date,
            photos,
        });
    }


function updateTaskArea(areaName) {
for (var i=0; i<areas.length; i++) {
  if (areas[i].name==areaName) {
      setCurrArea(areas[i]);
  }
}
}

    const deleteHarvest = (date, plant) => {
        const { areaIndex, plantIndex } = findPlantIndices(areas, plant.id);

        var removeIndex = -1;
        for (var i=0; i<plant.harvests.length; i++) {
            var harvestDate = plant.harvests[i].date
            if (harvestDate==date) {
                removeIndex = i;
                break;
            }
        }
        if (removeIndex>-1) {
            plant.harvests.splice(removeIndex, 1)
            var totalHarvest = 0
            for (var i=0; i<plant.harvests.length; i++) {
                totalHarvest += parseFloat(plant.harvests[i].amount)
            }
            plant.totalHarvest = totalHarvest
            onUpdateArea(areas[areaIndex])
        }

    };

    const deleteNote = (noteId) => {
        onDeleteJournalEntry(noteId);

    };
const foobar = "200px";

const saveProject = () => {
  // placehold for saving a project
}

const handleSelect = e => {
console.log(e);
}

return (
    <React.Fragment>
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col md={1}>
                        <Button
                            color="link"
                            size="lg"
                            onClick={handlePrevYear}
                            style={{marginRight: "10px"}}
                        >
                            ◀
                        </Button>
                    </Col>
                    <Col md={1}>
                        <h4>{currYear}</h4>
                    </Col>
                    <Col md={1}>
                        <Button
                            color="link"
                            size="lg"
                            onClick={handleNextYear}
                            style={{marginLeft: "10px"}}
                        >
                            ▶
                        </Button>
                    </Col>

                    <Col md={3}>
                    </Col>
                    <Col md={2} className="d-flex align-items-center">
                        <label
                            style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                fontSize: "0.85rem" // match .btn-sm font size
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={showCompleted}
                                onChange={(e) => setShowCompleted(e.target.checked)}
                                style={{
                                    appearance: "none",
                                    WebkitAppearance: "none",
                                    width: "14px",              // smaller box
                                    height: "14px",             // smaller box
                                    border: "2px solid #7c8b7b",
                                    borderRadius: "3px",
                                    backgroundColor: "#e3e7e4",
                                    cursor: "pointer",
                                    position: "relative",
                                    marginRight: "6px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            />

                            {showCompleted && (
                                <span
                                    style={{
                                        position: "absolute",
                                        marginLeft: "2px",
                                        fontSize: "10px",         // small checkmark that fits inside 14px box
                                        color: "#7c8b7b",
                                        pointerEvents: "none"
                                    }}
                                >
        ✔
      </span>
                            )}

                            <span
                                style={{
                                    color: "#545a6d",
                                    fontWeight: 500
                                }}
                            >
      Show Complete/Failed
    </span>
                        </label>
                    </Col>

                    <Col md={3}>
                        <div
                            className="btn-group btn-group-toggle"
                            data-toggle="views"
                        >
                            <label
                                className={
                                    normalView
                                        ? "btn btn-sm btn-secondary active"
                                        : "btn btn-sm btn-outline"
                                }
                            >
                                <input
                                    type="radio"
                                    name="viewoptions"
                                    id="viewoption1"
                                    onClick={() => {
                                        setNormalView(true);
                                        setCustomPlantsView(false);
                                        setSpreadsheetView(false);
                                    }}
                                />{" "}
                                Plant Info
                            </label>
                            <label
                                className={
                                    customPlantsView
                                        ? "btn btn-sm btn-secondary active"
                                        : "btn btn-sm btn-outline"
                                }
                            >
                                <input
                                    type="radio"
                                    name="viewoptions"
                                    id="viewoption2"
                                    onClick={() => {
                                        setNormalView(false);
                                        setCustomPlantsView(true);
                                        setSpreadsheetView(false);
                                    }}
                                />{" "}
                                Custom Plants
                            </label>
                            <label
                                className={
                                    spreadsheetView
                                        ? "btn btn-sm btn-secondary active"
                                        : "btn btn-sm btn-outline"
                                }
                            >
                                <input
                                    type="radio"
                                    name="viewoptions"
                                    id="viewoption2"
                                    onClick={() => {
                                        setNormalView(false);
                                        setCustomPlantsView(false);
                                        setSpreadsheetView(true);
                                    }}
                                />{" "}
                                Plant List
                            </label>

                        </div>
                    </Col>
                </Row>
                {spreadsheetView && (
                    <PlantGrid tableData={tableData} onCellEdit={cellChanged} areas={userareas}
                               plantColumnCatalog={plantColumnCatalog} addPlantToSpreadsheet={addPlantToSpreadsheet}
                               deletePlant={deletePlant} unitmeasurement={unitmeasurement}
                               addHarvest={addHarvest} deleteHarvest={deleteHarvest} showCompleted={showCompleted}
                               harvestDate={harvestDate} setHarvestDate={setHarvestDate}
                               harvestUnit={harvestUnit} setHarvestUnit={setHarvestUnit}
                               harvestAmount={harvestAmount} setHarvestAmount={setHarvestAmount}
                               noteDate={noteDate} setNoteDate={setNoteDate}
                               notes={notes} setNotes={setNotes} setNoteTags={setNoteTags} currYear={currYear}
                               setCurrYear={setCurrYear}
                               addPlantLog={addPlantLog} deleteNote={deleteNote}
                               onUpdateArea={onUpdateArea}
                               noteTags={noteTags} setNoteTags={setNoteTags}
                               selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles}
                               timelineNotes={timelineNotes} onCreateJournalEntry={onCreateJournalEntry}
                               onUpdateJournalEntry={onUpdateJournalEntry} username={username}
                               defaultColDef={{
                                   flex: 1, resizable: true,
                                   autoHeaderHeight: true,
                                   wrapHeaderText: true,
                               }}
                               onCellValueChanged={onCellValueChanged}/>
                )}
                {customPlantsView && (
                    <div>
                        {/* Header row */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                            <h5 style={{ margin: 0 }}>Custom Plants</h5>

                            <Button color="success" className="btn-sm" onClick={openCreateCustomPlantModal}>
                                + Create Custom Plant
                            </Button>
                        </div>

                        <Table responsive striped className="mb-0">
                            <thead style={{ backgroundColor: "#BEC8B6" }}>
                            <tr>
                                <th>Species</th>
                                <th>Lifecycle</th>
                                <th>Size</th>
                                <th>Days To Harvest</th>
                                <th>Guild Function</th>
                                <th>Food Forest Layer</th>
                                <th>Image</th>
                                <th>Actions</th>
                            </tr>
                            </thead>

                            <tbody>
                            {customplants.map((customplant) => (
                                <tr key={customplant.id || customplant.species}>
                                    <td>{customplant.species}</td>
                                    <td>{customplant.season_rotation}</td>
                                    <td>{customplant.size}</td>
                                    <td>{customplant.daysToHarvest}</td>
                                    <td>{Array.isArray(customplant.guildFunction) ? customplant.guildFunction.join(", ") : customplant.guildFunction}</td>
                                    <td>{Array.isArray(customplant.foodForestLayer) ? customplant.foodForestLayer.join(", ") : customplant.foodForestLayer}</td>

                                    <td>
                                        {customplant.cardIconKey ? (
                                            <StorageImage
                                                width="120px"
                                                alt={`${customplant.species}-card-icon`}
                                                imgKey={customplant.cardIconKey}
                                                accessLevel="guest"
                                                onStorageGetError={(error) => console.error(error)}
                                            />
                                        ) : customplant.icon ? (
                                            <StorageImage
                                                width="100px"
                                                alt={`${customplant.species}-icon`}
                                                imgKey={username + "-" + customplant.icon}
                                                accessLevel="guest"
                                                onStorageGetError={(error) => console.error(error)}
                                            />
                                        ) : null}
                                    </td>

                                    <td>
                                        <Button
                                            onClick={() => openEditCustomPlantModal(customplant)}
                                            color="#FFFFFF"
                                            className="btn-sm"
                                        >
                                            <i className="fas fa-edit fa-2x" />
                                        </Button>

                                        <Button
                                            onClick={() => handleDeleteCustomPlant(customplant.id)}
                                            color="#FFFFFF"
                                            className="btn-sm"
                                            title="Delete"
                                        >
                                            <i className="fas fa-trash-alt fa-2x" />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>

                        {/* The modal lives inside this tab so it’s contextually tied */}
                        <CustomPlantModal
                            isOpen={customPlantModalOpen}
                            toggle={() => setCustomPlantModalOpen((v) => !v)}
                            username={username}
                            mode={customPlantModalMode}
                            initialPlant={currCustomPlant}
                            onSave={handleSaveCustomPlant}
                            onUpdate={handleUpdateCustomPlant}
                            onDelete={handleDeleteCustomPlant}
                        />
                    </div>
                )}

{
    normalView && (<div><Row>
        <Col md={4}>
            <Card>
                <Row>
                    <Button
                        onClick={addArea}
                        style={{
                            backgroundColor: "#BEC8B6", // custom green
                            borderColor: "#4CAF50",
                    color: "#545a6d"
                }}
            >
                <i className="bx bx-add-to-queue" style={{ fontSize: "20px",  color: "#545a6d", marginRight: "6px" }} />
                <span style={{ color: "#545a6d" }} >Add Area</span>
            </Button>&nbsp;
            <Button
            onClick={logHarvests}
            style={{
                backgroundColor: "#BEC8B6", // custom green
                borderColor: "#4CAF50",
                color: "#545a6d"
            }}
        >
            <i className="bx bxs-shopping-bag" style={{ fontSize: "20px", color: "#545a6d", marginRight: "6px" }} />
        <span style={{color: "#545a6d" }} >Log Harvests</span>
        </Button>
            <Button
                onClick={() => setCropPlannerOpen(true)}
                style={{
                    backgroundColor: "#BEC8B6",
                    borderColor: "#4CAF50",
                    color: "#545a6d"
                }}
            >
                <i
                    className="bx bxs-shopping-bag"
                    style={{ fontSize: "20px", color: "#545a6d", marginRight: "6px" }}
                />
                <span style={{ color: "#545a6d" }}>Crop Planner</span>
            </Button>


        </Row>
</Card>
  </Col>


  </Row>

      {areas.filter((area, areaIndex) => {
          areaIndices[area.id] = areaIndex
          if (area.year == currYear) {
              return area;
          }
      }).map((area, index1) => (
<Area addPlantLog={addPlantLog} currYear={currYear}  deleteNote={deleteNote} showCompleted={showCompleted} noteTags={noteTags} notes={notes}
      noteDate={noteDate} deleteHarvest={deleteHarvest} addHarvest={addHarvest} transferPlant={transferPlant} profile={profile} unitmeasurement={unitmeasurement} guildResults={guildResults} addPlant={addPlant} calcPlantingCalendar={calcPlantingCalendar} areaExpand={areaExpand} climateAverages={climateAverages}
setAreaExpand={setAreaExpand} createNewPlant={createNewPlant} username={username} addPlantModal={addPlantModal} timelineData={timelineData}
 setTimelineData={setTimelineData} setAddPlantModal={setAddPlantModal} setNoteDate={setNoteDate} setNotes={setNotes} setNoteTags={setNoteTags} space={space} plantingCalendarOptions={plantingCalendarOptions} setTotalSpace={setTotalSpace}
 deletePlant={deletePlant} area={area} setAreas={setAreas} variety={variety} numPlants={numPlants} currPlant={currPlant} 
 customPlantEdit={customPlantEdit} onUpdateCustomPlant={onUpdateCustomPlant} onSaveCustomPlant={onSaveCustomPlant} 
 setCurrPlant={setCurrPlant} setCurrHarvests={setCurrHarvests} currHarvests={currHarvests} setTableData={setTableData}
  plantMap={plantMap} areas={areas} userareas={userareas} areaIndex={areaIndices[area.id]} onSearchGuild={onSearchGuild}
  onDeleteArea={onDeleteArea} transferModal={transferModal} setTransferModal={setTransferModal} onUpdateArea={onUpdateArea} onGetCustomPlants={onGetCustomPlants}
  timelineNotes={timelineNotes} onCreateJournalEntry={onCreateJournalEntry} onUpdateJournalEntry={onUpdateJournalEntry}/>
))}
</div>)}



    <Modal
        isOpen={cropPlannerOpen}
        toggle={() => setCropPlannerOpen(false)}
        size="xl"
        backdrop="static"
        centered
    >
        <ModalHeader toggle={() => setCropPlannerOpen(false)}>
            Crop Planner
        </ModalHeader>

        <ModalBody>
            <CropPlanner
                areas={areas}
                currYear={currYear}
                onAddRotationToArea={handleAddRotationToArea}
            />
        </ModalBody>
    </Modal>

                <CustomPlantModal
                    isOpen={plantModal}
                    toggle={() => setPlantModal((v) => !v)}
                    username={username}
                    mode={isCreatingCustomPlant ? "create" : "edit"}
                    initialPlant={currPlant}
                    onSave={(p) => onSaveCustomPlant(p)}
                    onUpdate={(p) => onUpdateCustomPlant(p)}
                    onDelete={(id) => onDeleteCustomPlant(id)}
                />


    <Modal isOpen={transferModal} toggle={() => {
        closeTransferModal()
    }}>
        <ModalHeader tag="h4">
            Transfer Plant to Other Areas
        </ModalHeader>

        <ModalBody>
            {transferError && (
                <Alert color="danger" toggle={() => setTransferError("")}>
                    {transferError}
                </Alert>
            )}
            <Row>
                <Col md={6}><strong>Plant:</strong></Col><Col>{currPlant.name || currPlant.species}</Col>
            </Row>
            <Row>
                <Col md={6}><strong>Variety:</strong></Col><Col>{currPlant.variety}</Col>
            </Row>
            <Row>
                <Col md={6}><strong>Available Plants:</strong></Col><Col>{currPlant.numPlants}</Col>
            </Row>
            <Row>
                <Col md={6}><strong>Remaining to Assign:</strong></Col><Col>{remainingPlants}</Col>
            </Row>

            <Row className="mb-1 fw-bold small text-muted">
                <Col md={5}>Area</Col>
                <Col md={4}># of Plants</Col>
                <Col md={3}></Col>
            </Row>

            {transferRows.map((row, index) => (
                <Row key={index} className="mb-2 align-items-center">
                    <Col md={5}>
                        <FormGroup className="mb-0">
                            <Input
                                type="select"
                                value={row.areaId}
                                onChange={(e) => handleTransferRowChange(index, "areaId", e.target.value)}
                            >
                                <option value="">Select Area</option>
                                {userareas.map(area => (
                                    <option key={area.id} value={area.id}>
                                        {area.name}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup className="mb-0">
                            <Input
                                type="number"
                                min="1"
                                max={currPlant.numPlants}
                                value={row.numPlants}
                                onChange={(e) => handleTransferRowChange(index, "numPlants", e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={3} className="text-end">
                        {transferRows.length > 1 && (
                            <i
                                className="fas fa-trash"
                                style={{ cursor: "pointer" }}
                                onClick={() => removeTransferRow(index)}
                            />
                        )}
                    </Col>
                </Row>
            ))}

            <div className="mt-3">
          <span
              style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline", fontSize: "0.9rem" }}
              onClick={addTransferRow}
          >
            + Add another area
          </span>
            </div>
        </ModalBody>

        <ModalFooter>
            <Button color="secondary" onClick={closeTransferModal}>
                Cancel
            </Button>
            <Button color="primary" onClick={handleTransfer} disabled={remainingPlants !== 0}>
                Transfer
            </Button>
        </ModalFooter>
    </Modal>


<Modal isOpen={editTaskModal} toggle={() => {
            editTask()
 }}
>
    <ModalHeader tag="h4">
        Edit Task 
    </ModalHeader>
    <ModalBody>
       <Form>
           <Row>
                         <Col md={6}><b>Type</b></Col>
                         <Col md={6}>
                               <Editable
                                      name="taskType"
                                      value={currTask.type}
                                      options={taskTypeOptions}
                                      dataType="select"
                                      display={(value) => {
                                         return (<span style={{color:"black"}}>{value}</span>);
                                      }}
                                      mode="inline"
                                      handleSubmit={taskChange}
                                />
                         </Col>

                      </Row>
             <Row>
                         <Col md={6}><b>Area</b></Col>
                         <Col md={6}>
                               <Editable
                                      name="taskArea"
                                      value={currTask.area}
                                      options={areas.map(area => ({ value: area.name, text: area.name }))}
                                      dataType="select"
                                      mode="inline"
                                      handleSubmit={taskChange}
                                />
                         </Col>

                      </Row>
	 <Row>
              <Col md={6}><b>Plants</b></Col>
              <Col md={6}>
	             <Editable
                                      name="taskPlants"
                                      value={currTask.plants}
                                      options={plantOptions}
                                      dataType="select"
                                      mode="inline"
                                      handleSubmit={taskChange}
                                />
              </Col>
         </Row>
  <Row>
              <Col md={6}><b>Objective</b></Col>
              <Col md={6}>
	               <Editable
                                      name="taskObjective"
                                      value={currTask.objective}
                                      dataType="text"
                                      mode="inline"
                                      handleSubmit={taskChange}
                                />

              </Col>
         </Row>
<Row>
              <Col md={6}><b>Status</b></Col>
              <Col md={6}>
                     <Editable
                                      name="taskStatus"
                                      value={currTask.status}
                                      options={taskStatusOptions}
                                      dataType="select"
                                      mode="inline"
                                      handleSubmit={taskChange}
                                />
              </Col>
         </Row>
  <Row>
              <Col md={6}><b>Start Date</b></Col>
              <Col md={6}>
	            <Editable
                                      name="taskStartDate"
                                      value={currTask.endDate}
                                      dataType="date"
                                      mode="inline"
                                      handleSubmit={taskChange}
                      />

              </Col>
         </Row>

        </Form>
    </ModalBody>
</Modal>


<Modal isOpen={addPlantModal} toggle={() => {

 }}
>
    <ModalHeader tag="h4">
        New Plant
    </ModalHeader>
    <ModalBody>
	 <Form>
        {spreadsheetView &&  (<Row style={{marginBottom: "5px"}}>
              <Col><b>Area</b></Col>
              <Col>
                   <Input type="select"  onChange={event => {
                               setAreaSelected(event.target.value);
                          }}
>
                         <option value=""></option>
                       {areas
                           .filter((area) => area.year === currYear)
                           .map((area) => (
                               <option key={area.id || area.name} value={area.name}>
                                   {area.name}
                               </option>
                           ))}
                   </Input>
              </Col>
         </Row>
        )}

<Row style={{marginBottom: "5px"}}>
              <Col><b>Species</b></Col>
              <Col>
                  <PlantSelect
                      plantOptions={plantOptions.map(plantItem => ({
                          key: plantItem.value,
                          label: plantItem.value
                      }))}
                      value={""} // or some state variable for the current value
                      onChange={(val) => updateSpecies(val)}
                  />
                   <span style={{color:"#FF0000"}}>{errors['species']}</span>
              </Col>
         </Row>
         {currPlant.season!='perennial' && <Row style={{marginBottom: "5px"}}>
                         <Col md={6}>Season</Col>
              <Col md={6}>
                    <Input type="select" onChange={event => {
                               setSeasonRotation(event.target.value);
                          }}>
                        <option value=""></option>
                         <option value="Spring">Spring</option>
                         <option value="Summer">Summer</option>
                         <option value="Fall">Fall</option>
                         <option value="Winter">Winter</option>
                    </Input>
                  <span style={{color:"#FF0000"}}>{errors['season']}</span>
              </Col>
                      </Row>}
	 <Row style={{marginBottom: "5px"}}>
              <Col md={6}><b>Variety</b></Col>
              <Col md={6}>
                  <Input type="text" value={variety} onChange={event => {
                      setVariety(event.target.value);
                  }}
                  />
              </Col>
         </Row>
         <Row style={{marginBottom: "5px"}}>
              <Col md={6}><b>Growing Phase</b></Col>
             <Col md={6}>
                 <Input type="select" onChange={event => {
                     setPlantStatus(event.target.value);
                 }}>
                     <option value=""></option>
                     <option value="Purchased">Purchased</option>
                     <option value="Not Started">Not Started</option>
                     <option value="Seed Starting">Seed Starting</option>
                     <option value="Transplanting">Transplanting</option>
                     <option value="Growing">Growing</option>
                     <option value="Harvest">Harvest</option>
                     <option value="Failed">Failed</option>
                     <option value="Completed">Completed</option>
                 </Input>
                 <span style={{color: "#FF0000"}}>{errors['status']}</span>
             </Col>
         </Row>
         <Row style={{marginBottom: "15px"}}>
         <Col md={6}><b>Number of Plants</b></Col>
              <Col md={6}>
                    <Input type="text" value={numPlants} onChange={event => {
                               setNumPlants(event.target.value);
                          }}
/>
                    <span style={{color: "#FF0000"}}>{errors['numPlants']}</span>
              </Col>
        </Row>
         {currPlant!='' && plantStatus=='Purchased' &&
             <Row style={{marginBottom: "10px"}}>
                 <Col md={6}>
                     <b>Source</b>
                 </Col>
                 <Col md={6}>
                     <Input type="text" value={plantSource} onChange={event => {
                         setPlantSource(event.target.value);
                     }}
                     />
                 </Col>
             </Row>
         } {currPlant!='' && plantStatus=='Purchased' &&
             <Row style={{marginBottom: "10px"}}>
                  <Col md={6}>
                     <b>Order Date</b>
                  </Col>
                  <Col md={6}>
                      <Input
                          name="orderDate"
                          value={orderDate}
                          type="date"
                          onChange={event => {
                              setOrderDate(event.target.value);
                          }}
                      />
                  </Col>
              </Row>
     } {currPlant!='' && plantStatus=='Purchased' &&
              <Row style={{marginBottom: "10px"}}>
                  <Col md={6}>
                     <b>Expected Delivery Date</b>
                  </Col>
                  <Col md={6}>
                     <Input
                        name="expectedDeliveryDate"
                        value={expectedDeliveryDate}
                        type="text"
                        onChange={event => {
                           setExpectedDeliveryDate(event.target.value);
                        }}
                     />
                   </Col>
              </Row>
         }
        {currPlant!='' && (currPlant.season=='annual' || currPlant.season=='biennial') &&
         <div>
          <Row style={{marginBottom: "10px"}}>
             <Col md={7}>
                     <b>Use Last Possible Date</b> 
                        </Col>
             <Col md={5}>
            <Input
                          type="checkbox"
                          checked={lastDatePossible}
                         onChange={event => {
                               setLastDatePossible(event.target.checked);
                          }}
                        />
              </Col>
          </Row>
          </div>
        }
	<Row>
              <Col md="4"/>
              <Col md="2">
                   <Button
                       onClick={e => { createNewPlant()  }}
                       color="success"
                       className="btn-sm"
                    >
                     Create
                   </Button>
              </Col>
              <Col md="2">
                  <Button
                       onClick={e => { cancelNewPlant()  }}
                       color="primary"
                       className="btn-sm"
                    >
                     Cancel
                   </Button>
              </Col>
            </Row>

        </Form>
    </ModalBody>
</Modal>


<Modal isOpen={plantingCalendarModal} toggle={() => {
     closePlantingCalendar()

 }}
>
    <ModalHeader tag="h4">
        {plantingDates && <span>Planting Window For {currPlant.species} (in green overlay)</span>}
        {!plantingDates && <span>No Planting Window for {currPlant.species}</span>}
    </ModalHeader>
    <ModalBody>
         <Row style={{ paddingTop: "10px"}}>
              <Col md="12">
               {plantingDates && <ReactApexChart
        options={{ ...plantingCalendarOptions, annotations: annotations }} series={climateAverages}
        height={400}
        type="area"
         />}
          {!plantingDates && 
            <div><Row>
            <Col md="12"><ReactApexChart
        options={{ ...plantingCalendarOptions}} series={climateAverages}
        height={400}
        type="area"
         /></Col>
            </Row>
            <Row>
               <Col md="12">
                <div><p>Unable to find an adequate planting window for this plant given your climate and season requirements.
                    Takes {currPlant.daysToHarvest} days to harvest from transplant. However, There are not enough contiguous
                    days in your climate for you to grow this plant to harvest.
                </p>
                     {plantingMonths.start && <p> The closest window that comes closest to meeting your needs for this plant are from
                        &nbsp;{plantingMonths.start} - {plantingMonths.end}, a total of {plantingMonths.diff} days.</p>
                    }
                    <p>You can try to extend your season (microclimates or protective row cover) or grow a variety of
                        this plant with a shorter time to maturity.  For now, the planting dates have not been populated for this plant, but
                        can be changed manually.</p>
                </div>
                </Col>
            </Row>
            </div>
            }
              </Col>
            </Row>

    </ModalBody>
</Modal>


    <Modal isOpen={addAreaModal} toggle={() => {}}>
        <ModalHeader tag="h4">New Area</ModalHeader>

        <ModalBody>
            <Form>

                {/* Copy From Previous Year */}
                <Row style={{ paddingBottom: "10px" }}>
                    <Col md={6}><b>Copy areas from last year</b></Col>
                    <Col md={6}>
                        <Input
                            type="checkbox"
                            checked={copyFromPrevious}
                            onChange={e => setCopyFromPrevious(e.target.checked)}
                        />
                    </Col>
                </Row>

                {!copyFromPrevious && (
                    <>
                        <Row>
                            <Col md={6}><b>Name</b></Col>
                            <Col md={6}>
                                <Input
                                    type="text"
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                />
                                <span style={{ color: "#FF0000" }}>{errors['name']}</span>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <b>Total Space ({unitmeasurement === "imperial" ? "ft²" : "m²"})</b>
                            </Col>
                            <Col md={6}>
                                <Input
                                    type="text"
                                    value={space}
                                    onChange={e => setTotalSpace(e.target.value)}
                                />
                                <span style={{ color: "#FF0000" }}>{errors['space']}</span>
                            </Col>
                        </Row>
                    </>
                )}

                <Row style={{ paddingTop: "10px" }}>
                    <Col md="4" />
                    <Col md="2">
                        <Button
                            onClick={createNewArea}
                            color="success"
                            className="btn-sm"
                        >
                            Create
                        </Button>
                    </Col>

                    <Col md="2">
                        <Button
                            onClick={cancelNewArea}
                            color="primary"
                            className="btn-sm"
                        >
                            Cancel
                        </Button>
                    </Col>
                </Row>

            </Form>
        </ModalBody>
    </Modal>



    <Modal isOpen={logHarvestsDialog} toggle={closeLogHarvests}>
        <ModalHeader tag="h4">
            Log Harvests
        </ModalHeader>
        <ModalBody>
            <Form>
                <FormGroup check className="mb-3">
                    <Input
                        type="checkbox"
                        id="include-varieties"
                        checked={includeVarieties}
                        onChange={() => setIncludeVarieties(prev => !prev)}
                    />
                    <Label check for="include-varieties">Include Varieties</Label>
                </FormGroup>

                {/* Editable Harvest Date */}
                <Row className="mb-3">
                    <Col md={4}><Label>Harvest Date</Label></Col>
                    <Col md={8}>
                        <DatePicker
                            selected={logHarvestDate}
                            onChange={(date) => setLogHarvestDate(date)}
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                        />
                    </Col>
                </Row>

                {/* Table Headers */}
                <Row className="fw-bold small text-muted mb-1">
                    <Col md={7}>Plant / Variety</Col>
                    <Col md={3}>{unitmeasurement == "imperial" ? "Ounces" : "Grams"}</Col>
                    <Col md={2}></Col>
                </Row>

                {/* Dynamic Harvest Rows */}
                {logHarvestRows.map((row, index) => (
                    <Row key={index} className="mb-2 align-items-center">
                        <Col md={7}>
                            <PlantSelect
                                plantOptions={harvestPlantOptions}
                                value={row.plantName + "__" + row.variety}
                                onChange={(val) => handleLogHarvestsRowChange(index, "plantKey", val)}
                            />
                        </Col>
                        <Col md={3}>
                            <Input
                                type="number"
                                min="0"
                                step="0.1"
                                value={row.ounces}
                                onChange={e =>
                                    handleLogHarvestsRowChange(index, "ounces", e.target.value)
                                }
                            />
                        </Col>
                        <Col md={2} className="text-end">
                            {logHarvestRows.length > 1 && (
                                <i
                                    className="fas fa-trash"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => removeLogHarvestRow(index)}
                                />
                            )}
                        </Col>
                    </Row>
                ))}

                {/* Add Row Link */}
                <div className="mt-2 mb-4">
        <span
            style={{
                cursor: "pointer",
                color: "#007bff",
                textDecoration: "underline",
                fontSize: "0.9rem"
            }}
            onClick={addLogHarvestRow}
        >
          + Add another harvest
        </span>
                </div>

                {/* Action Buttons */}
                <Row style={{ paddingTop: "10px" }}>
                    <Col md="4" />
                    <Col md="2">
                        <Button
                            onClick={e => createNewHarvestLog()}
                            color="success"
                            className="btn-sm"
                        >
                            Create
                        </Button>
                    </Col>
                    <Col md="2">
                        <Button
                            onClick={e => closeLogHarvests()}
                            color="primary"
                            className="btn-sm"
                        >
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </Form>
        </ModalBody>
    </Modal>


    <Modal isOpen={welcomeModal}  toggle={() => {
        closeWelcome()
    }} size="lg" centered>
        <ModalHeader  toggle={() => {
            closeWelcome()
        }}>
            Welcome to Plants!
        </ModalHeader>
        <ModalBody>
            <Row>
                {/* Left Column: Explanatory Text */}
                <Col md={6}>
                    <h5>Plant Data Central</h5>
                    <p>
                        Plants is SAGE's feature for managing all aspects of your plant data.
                        When you start out in Plants, you will see an "Add Area" button that allows
                        you to start adding Garden Areas to your garden.  You'll also have an initial garden
                        area called Unassigned for holding plants that you haven't figured out where to place yet.
                        The introduction video on the right will guide you through setting up your first garden area with a season's
                        worth of plants.
                    </p>
                    <p>
                        Once you feel comfortable adding garden beds, you can learn more about how to do
                        advanced garden design using Plants in our <a href="https://permaculturegardens.org/sage-documentation">documentation</a> section.
                    </p>
                </Col>

                {/* Right Column: Video */}
                <Col md={6}>
                    <div className="embed-responsive embed-responsive-16by9">
                        <iframe
                            className="embed-responsive-item"
                            src="https://www.youtube.com/embed/7F4Onurgh-A?si=39SSKvoQV7ItM3BV"
                            title="Welcome Video"
                            allowFullScreen
                        ></iframe>
                    </div>
                </Col>
            </Row>
        </ModalBody>
        <div className="d-flex justify-content-end p-3">
            <Button color="primary" onClick={() => {
                closeWelcome()
            }}>
                Get Started
            </Button>
        </div>
    </Modal>

        </Container>
      </div>
    </React.Fragment>
  )
}

PlantList.propTypes = {
  resources: PropTypes.array,
}

const mapStateToProps = (state, ownProps) => {
  const sortedPlants = state.designer.plants.sort((a, b) => (a.name > b.name) ? 1 : -1);
  const sortedArea = state.designer.plants.sort((a, b) => (a.name > b.name) ? 1 : -1);
  const plantFun = sortedPlants.reduce((map, obj) => (map[obj.name] = obj, map), {});

    var filteredAreas = state.goals.areas
        .map(area => {
            const deepCopyArea = structuredClone(area);
            deepCopyArea.plants = deepCopyArea.plants.filter(plant => plant.species !== undefined);
            return deepCopyArea;
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    return {
        plantMap: plantFun,
        plantData: sortedPlants,
        profile: state.Profile.user,
        userareas: filteredAreas,
        designs: state.designer.designs,
        climateData: state.designer.temps,
        customplants: state.goals.customplants,
        guildResults: state.goals.plants,
        timelineNotes: Array.isArray(state.journal.timelineNotes) ? state.journal.timelineNotes : [],
  }
}

const mapDispatchToProps = dispatch => ({
    onGetPlantData: () => dispatch(getPlantData()),
    onGetProfile: (username) => dispatch (getProfile(username)),
    onUpdateArea: area => dispatch(updateArea(area)),
    onGetCustomPlants: () => dispatch(fetchCustomPlants()),
    onSaveCustomPlant: plant => dispatch(saveCustomPlant(plant)),
    onUpdateCustomPlant: plant => dispatch(updateCustomPlant(plant)),
    onGetClimateData: (zipcode) => dispatch(getClimateData(zipcode)),
    onAddNewEvent: event => dispatch(addNewEvent(event)),
    onDeleteEvent: event => dispatch(deleteEvent(id)),
    onAddArea: area => dispatch(addArea(area)),
    onDeleteArea: id => dispatch(deleteArea(id)),
    onSaveDesign: (design) => dispatch(updateDesign(design)),
    onLoadDesigns: () => dispatch(getDesigns()),
    onDeleteCustomPlant: id => dispatch(deleteCustomPlant(id)),

    onGetAreas: () => dispatch(getAreas()),
    onSearchGuild: searchGuildParams => dispatch(searchGuild(searchGuildParams)),
    onCreateJournalEntry: data => dispatch(createJournalEntry(data)),
    onDeleteJournalEntry: noteId => dispatch(deleteJournalEntry(noteId)),
    onGetJournalTimeline: params => dispatch(getJournalTimeline(params)),
    onUpdateJournalEntry: data => dispatch(updateJournalEntry(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PlantList))
